// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:35:39.948Z
// Property: The Ridge @ 66 (ID: 6767906449165636)
// Collections: 19 amenities, 13 floorplans (live), 41 photos, 68 POIs, 2 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165636",
  "property_external_id": "bdmlnc9",
  "property_zillow_url": "https://www.zillow.com/apartments/yukon-ok/the-ridge-%40-66/C66xwQ/",
  "property_apartments_url": "https://www.apartments.com/the-ridge-66-yukon-ok/bdmlnc9/",
  "property_google_business_url": "https://www.google.com/maps/place/Ridge+at+66+Apts/data=!4m2!3m1!1s0x0:0xf102ca8fab14487c?sa=X&ved=2ahUKEwjg_7HAgb2SAxVFHjQIHXtiAfAQ_BJ6BAgSEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-ridge-@-66",
  "property_name": "The Ridge @ 66",
  "property_website_url": "https://www.caseusa.com/apartments/ok/yukon/ridge-at-66/",
  "property_domain": null,
  "property_address": "4300 Caravel Dr.",
  "property_full_address": "4300 Caravel Dr., Yukon, OK, 73099",
  "property_address_1": "4300 Caravel Dr.",
  "property_address_2": null,
  "property_address_city": "Yukon",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "73099",
  "property_address_country": "US",
  "property_address_county": "Canadian County",
  "property_neighborhood_address": "Stonebridge West",
  "property_address_latitude": "35.5136",
  "property_address_longitude": "-97.7019",
  "property_email": "ridgeat66@caseusa.com",
  "property_phone": "(405) 497-8702",
  "property_call_tracking_phone": "866-561-5814",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to The Ridge @ 66 in Yukon, Oklahoma, where stylish living meets unparalleled amenities. Whether you choose a cozy one-bedroom or a spacious three-bedroom, enjoy resort-style perks like a sparkling pool, inviting clubhouse, and a dedicated pet play area. Your perfect home awaits—eager to explore? Schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to The Ridge @ 66, your ideal apartment community nestled in the heart of Yukon, Oklahoma. Offering beautifully designed One, Two, and Three Bedroom floor plans, our spacious homes are perfect for any lifestyle. From the moment you step inside, you'll appreciate the modern features, including stainless steel appliances, walk-in closets, and inviting balconies or patios for your own outdoor oasis.\n\nAt The Ridge @ 66, we prioritize your comfort and convenience. Enjoy a range of exceptional amenities designed to enhance your living experience. Dive into relaxation at our sparkling pool, break a sweat at our fully-equipped fitness center, or unwind in our stylish clubhouse. Plus, with a dedicated business center, you'll have everything you need to balance work and play.\n\nOur community is pet-friendly, featuring a designated pet play area for your furry friends. For those who love staying active, take advantage of our basketball court and take leisurely strolls through our gated grounds. With 24-hour access and an onsite property manager, you’ll see just how easy it is to call The Ridge @ 66 home.\n\nDon’t miss out on the opportunity to live in this vibrant community that offers the perfect mix of comfort and convenience. Find your new home today—browse our availability or schedule a tour to visit our community! The Ridge @ 66 is where your ideal lifestyle awaits.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019fb44b-b61c-7551-9037-12526761bd0a.webp",
  "property_featured_image_media": {
    "alt_text": "Apartment complex outdoor swimming pool with lounge chairs and umbrellas.",
    "public_id": "019fb44b-b61c-7551-9037-12526761bd0a",
    "storage_key": "property/6767906449165636/019fb44b-b61c-7551-9037-12526761bd0a.webp",
    "width": 1280,
    "height": 853
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "339",
  "property_year_built": "2024",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.93510324483776",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": "150-575",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Maximum of two pets per unit. Breed restrictions apply.",
  "property_pet_policy_description": "We welcome both cats and dogs. No weight limit. Maximum of two pets per unit. Breed restrictions apply. One-time non‑refundable fee: $500 per pet. Monthly pet rent: $30 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://ridgeat66apartmentsyukon.securecafe.com/onlineleasing/the-ridge-66/floorplans.aspx",
  "property_resident_portal_url": "https://ridgeat66apartmentsyukon.securecafe.com/residentservices/the-ridge-66/userlogin.aspx",
  "property_apply_now_url": "https://ridgeat66apartmentsyukon.securecafe.com/onlineleasing/the-ridge-66/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-54c4-720b-a7de-ea34beac3e88.webp",
  "property_primary_logo_media": {
    "alt_text": "Ridge at 66 Apartment Homes logo",
    "public_id": "019cfb4a-54c4-720b-a7de-ea34beac3e88",
    "storage_key": "property/6767906449165636/019cfb4a-54c4-720b-a7de-ea34beac3e88.webp",
    "width": 700,
    "height": 152
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4b-c231-7589-bb4f-12306265e578.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb4b-c231-7589-bb4f-12306265e578",
    "storage_key": "property/6767906449165636/019cfb4b-c231-7589-bb4f-12306265e578.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4b-e60e-724c-8992-ee89faba3371.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Ridge at 66 Apartment Homes logo",
    "public_id": "019cfb4b-e60e-724c-8992-ee89faba3371",
    "storage_key": "property/6767906449165636/019cfb4b-e60e-724c-8992-ee89faba3371.webp",
    "width": 640,
    "height": 139
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4b-f0e0-7140-b405-4f6711a01718.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Ridge at 66 Apartment Homes logo",
    "public_id": "019cfb4b-f0e0-7140-b405-4f6711a01718",
    "storage_key": "property/6767906449165636/019cfb4b-f0e0-7140-b405-4f6711a01718.webp",
    "width": 640,
    "height": 139
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#4c5646",
  "property_secondary_color": "#dbbb6b",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#d4af37",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "789 - 1473",
  "property_sqft_min": "789",
  "property_sqft_max": "1473",
  "property_price_range": "1159 - 1729",
  "property_price_min": "1159",
  "property_price_max": "1729",
  "property_available_units": 7,
  "property_facebook_url": "https://www.facebook.com/Ridgeat66Apts/",
  "property_instagram_url": "https://www.instagram.com/ridgeat66apts/?hl=en",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ72kiz4oHsocRfEgUq4_KAvE",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?cflt=apartments&find_near=ridge-at-66-apartments-yukon",
  "property_tiktok_url": "https://www.tiktok.com/discover/the-ridge-at-66-yukon",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Ridge @ 66",
  "property_home_romance_title": "Embrace a Cozy Life in Your New Apartment Sanctuary",
  "property_home_amenities_blurb": "At The Ridge @ 66 in Yukon, Oklahoma, your ideal lifestyle awaits! Choose from spacious one, two, or three-bedroom apartments featuring modern comforts like stainless steel appliances and walk-in closets. Enjoy resort-style amenities including a sparkling pool, dog park, and vibrant clubhouse. Experience the perfect blend of comfort and convenience!",
  "property_home_floorplans_blurb": "At The Ridge @ 66 in Yukon, Oklahoma, your ideal living space awaits! Choose from our thoughtfully designed one, two, or three-bedroom apartments, each tailored for your comfort and style. Dive into a world of options and embrace the lifestyle you've always wanted—your perfect home is just a click away!",
  "property_home_gallery_blurb": "Welcome to The Ridge @ 66 in Yukon, Oklahoma, where modern living meets comfort! Choose from our spacious one, two, or three-bedroom floor plans, each featuring stylish amenities like stainless steel appliances and walk-in closets. With a resort-style pool, pet-friendly areas, and a vibrant clubhouse, picture yourself living here!",
  "property_home_neighborhood_blurb": "At The Ridge @ 66 in Yukon, Oklahoma, you'll find a vibrant community nestled among local treasures. Whether you choose a cozy one-bedroom or a spacious three-bedroom apartment, step out to enjoy nearby parks, dining, and entertainment. Uncover the charm of our neighborhood and all it has to offer!",
  "property_home_reviews_blurb": "At The Ridge @ 66 in Yukon, Oklahoma, residents rave about the community vibes, stating it’s “more than just a place to live; it feels like home.” Experience the warmth and friendliness that sets us apart. Curious about our exceptional lifestyle? Hear directly from our satisfied residents!",
  "property_neighborhood_blurb": "At The Ridge @ 66 in Yukon, Oklahoma, your new home is nestled among renowned educational institutions like Southern Nazarene University and Oklahoma City University. With spacious one, two, and three-bedroom floor plans, you’ll find comfort close to excellent schools and vibrant community spots. Discover the convenience of your new neighborhood!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At The Ridge @ 66 in Yukon, experience modern living with one, two, and three-bedroom floor plans tailored for comfort. Unwind by the refreshing pool, break a sweat in the fitness center, or relax in the stylish clubhouse. Enjoy 24-hour access and pet-friendly spaces—all in a gated community designed for you.",
  "property_applynow_blurb": "Welcome to The Ridge @ 66 in Yukon, Oklahoma—where comfort meets convenience! Choose from one, two, or three-bedroom floor plans, all designed for your lifestyle. Enjoy amenities like a refreshing pool, clubhouse, and pet play area. Find your new home and lease online today!",
  "property_contactus_blurb": "At The Ridge @ 66 in Yukon, Oklahoma, we offer a variety of thoughtfully designed floor plans, including one, two, and three-bedroom apartments tailored to fit your lifestyle. Have questions? Our leasing team is eager to assist you—reach out today for personalized guidance!",
  "property_faqs_blurb": "At The Ridge @ 66 in Yukon, Oklahoma, our diverse floor plans—ranging from cozy one-bedroom retreats to spacious three-bedroom havens—cater to every lifestyle. Curious about community perks and policies? Navigate to our FAQs page for clear answers to your top questions and discover what makes us truly unique!",
  "property_floorplans_blurb": "At The Ridge @ 66 in Yukon, Oklahoma, our thoughtfully designed floor plans cater to every lifestyle. Whether you crave the cozy intimacy of a one-bedroom, the spaciousness of a two-bedroom, or the grandeur of a three-bedroom, each apartment reflects your unique style. Browse our available homes today!",
  "property_gallery_blurb": "At The Ridge @ 66 in Yukon, Oklahoma, imagine unwinding by the pool or enjoying a barbecue with friends in our cabana. With stylish one, two, and three-bedroom floor plans, modern amenities like a fitness center and pet play area, you’ll find the perfect place to create lasting memories. Picture yourself living here!",
  "property_interactivemap_blurb": "Welcome to The Ridge @ 66 in Yukon, Oklahoma, where modern comfort meets convenience. Choose from spacious one, two, and three-bedroom floor plans. Enjoy exclusive amenities like a sparkling pool, fitness center, and pet-friendly spaces. Utilize our interactive community map to find your perfect home today!",
  "property_pets_blurb": "At The Ridge @ 66 in Yukon, OK, your furry friends are part of the family! Enjoy spacious living with no weight limit on cats and dogs—just ensure your pets meet breed requirements. With a vibrant community and pet-friendly amenities, it’s the perfect place for you and your four-legged companions.",
  "property_referafriend_blurb": "At The Ridge @ 66 in Yukon, Oklahoma, a place where great friendships flourish alongside spacious one, two, and three-bedroom floor plans awaits you. Share the joy of community living—refer a friend today and create the perfect neighborly bond. Together, let’s build memories that last a lifetime!",
  "property_residentaccess_blurb": "Welcome to The Ridge @ 66 in Yukon, Oklahoma, where spacious floor plans range from cozy one-bedroom to expansive three-bedroom apartments. Access your resident portal easily to pay rent, schedule maintenance, and enjoy seamless living. Join a community that blends comfort with convenience—your new home awaits!",
  "property_reviews_blurb": "At The Ridge @ 66 in Yukon, Oklahoma, residents rave about their experience: \"The community feels like home, and the staff truly care!\" Dive into our reviews to uncover the warmth and camaraderie that make living here special. See what our residents have to say about living at our community!",
  "property_created_at": "1753982395112",
  "property_scheduletour_blurb": "At The Ridge @ 66 in Yukon, Oklahoma, find your perfect space among our thoughtfully designed one, two, and three-bedroom floor plans. Experience vibrant community living and hear firsthand from our residents about their joyful experience. Schedule your tour today and envision your new life in our welcoming sanctuary!",
  "property_thankyou_blurb": "Thank you for connecting with The Ridge @ 66 in Yukon, Oklahoma! Our diverse floor plans, ranging from one to three bedrooms, are designed to fit your lifestyle. Stay tuned, as a member of our team will be in touch soon to help you find your perfect home!",
  "property_virtualtours_blurb": "Welcome to The Ridge @ 66 in Yukon, Oklahoma, where your dream apartment awaits! Choose from our thoughtfully designed one, two, or three-bedroom floor plans tailored to your lifestyle. Get a sneak peek of our vibrant community and spacious interiors—take a virtual tour today and envision your new home!",
  "property_copyright": "2025 All Rights Reserved. The Ridge @ 66",
  "property_seo_title_home": "The Ridge @ 66 | Apartments in Yukon, Oklahoma",
  "property_seo_description_home": "Elevate your lifestyle at The Ridge @ 66 in Yukon, OK. Choose from spacious one, two, or three-bedroom plans with top-notch amenities. Find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Yukon, Oklahoma",
  "property_seo_description_floorplans": "Find your ideal living space at The Ridge @ 66 in Yukon, OK! Choose from stylish one, two, and three-bedroom floor plans tailored for modern living.",
  "property_seo_title_amenities": "Amenities | Yukon, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Unwind at The Ridge @ 66 in Yukon, OK! Enjoy spacious floor plans, a refreshing pool, and top-notch amenities like a fitness center, cabana, and pet play area!",
  "property_seo_title_gallery": "Gallery | Apartments in Yukon, Oklahoma",
  "property_seo_description_gallery": "Capture your ideal lifestyle at The Ridge @ 66 in Yukon, OK! Dive into our stunning photo gallery showcasing inviting amenities and spacious floor plans.",
  "property_seo_title_virtualtours": "Virtual Tours | The Ridge @ 66 Apartments",
  "property_seo_description_virtualtours": "Experience The Ridge @ 66 in Yukon, OK! Take a virtual tour of our stylish one to three-bedroom apartments and find your perfect home today!",
  "property_seo_title_interactivemap": "Interactive Map | The Ridge @ 66 Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at The Ridge @ 66 in Yukon, OK! Enjoy spacious floor plans, fantastic amenities, and a vibrant community. Use our map to start your journey!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Yukon, Oklahoma",
  "property_seo_description_neighborhood": "Uncover the charm of Yukon at The Ridge @ 66. Dive into local favorites and must-visit spots just steps from your new one, two, or three-bedroom home!",
  "property_seo_title_contact": "Contact Us | The Ridge @ 66",
  "property_seo_description_contact": "Connect with The Ridge @ 66 in Yukon, OK! Whether you're seeking a cozy one-bedroom or a spacious three-bedroom, our leasing team is here to help you find your perfect home.",
  "property_seo_title_faqs": "FAQs | Apartments in Yukon, Oklahoma",
  "property_seo_description_faqs": "Uncover answers to your top questions at The Ridge @ 66 in Yukon, OK. Enjoy luxury living with pools, fitness, and pet-friendly amenities. Your new home awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Yukon, Oklahoma",
  "property_seo_description_reviews": "Experience life at The Ridge @ 66 in Yukon, Oklahoma. Dive into resident reviews and see why our spacious homes and stellar amenities make us the ideal choice!",
  "property_seo_title_applynow": "Apply Now | Apartments in Yukon, Oklahoma",
  "property_seo_description_applynow": "Experience comfort at The Ridge @ 66 in Yukon! Choose from spacious one, two, or three-bedroom plans with resort-style amenities. Apply online and find your perfect home!",
  "property_seo_title_residentaccess": "Resident Access | The Ridge @ 66",
  "property_seo_description_residentaccess": "Unlock convenience at The Ridge @ 66 in Yukon, OK! Log in to manage your rent, request maintenance, and stay connected with your community. Access now!",
  "property_seo_title_referafriend": "Refer A Friend | The Ridge @ 66",
  "property_seo_description_referafriend": "\"Great friends make great neighbors! Refer a friend to The Ridge @ 66 in Yukon, OK, and share the joy of vibrant apartment living. Join our community!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | The Ridge @ 66",
  "property_seo_description_scheduletour": "Experience the charm of The Ridge @ 66 in Yukon, OK! Schedule a tour today and envision your new lifestyle in our vibrant, welcoming community.",
  "property_seo_title_privacy": "Privacy Policy | The Ridge @ 66",
  "property_seo_description_privacy": "At The Ridge @ 66 in Yukon, OK, your privacy matters. Safeguard your peace of mind—review our comprehensive privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | The Ridge @ 66",
  "property_seo_description_accessibility": "\"At The Ridge @ 66 in Yukon, we prioritize digital inclusion for all. Experience tailored accessibility that enhances your living journey with us.\"",
  "property_seo_title_sitemap": "Sitemap | The Ridge @ 66",
  "property_seo_description_sitemap": "Navigate your way to comfort and community at The Ridge @ 66 in Yukon, OK. Check out our sitemap for an easy path to your new home sweet home!",
  "property_seo_title_thankyou": "Thank You | The Ridge @ 66",
  "property_seo_description_thankyou": "Thank you for reaching out to The Ridge @ 66! Your inquiry is on its way, and we’ll connect soon to share how your new home in Yukon awaits.",
  "property_seo_title_pets": "Pet Policy | Apartments in Yukon, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787866001990",
  "amenities": [
    {
      "id": "ec_a358478fd03ebc54d675d9f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "yardi",
      "external_id": "127397331",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5d999fd5f56a380cb8cbcd12",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "yardi",
      "external_id": "127397332",
      "title": "Clubhouse w/ Billiards & Shuffleboard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6a78ee8c3431ccbf281955a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "yardi",
      "external_id": "127397333",
      "title": "24/7 Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_57350cfaac313d5a925df704",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "yardi",
      "external_id": "127397334",
      "title": "Limited Access Gated Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eea92d191b2f9a6d060a54ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "yardi",
      "external_id": "127397335",
      "title": "Resort-Style Pool w/ Tanning Ledges & Cabanas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a3c0a55b3f2447a2d65f535b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "yardi",
      "external_id": "127397336",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7b042ea5ff68110baaa43017",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "yardi",
      "external_id": "127397337",
      "title": "Onsite Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3fb3ffb1f3d83a5419e5fc9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "yardi",
      "external_id": "127397339",
      "title": "Onsite Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_53597f3326e2d4c13255db79",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "yardi",
      "external_id": "127397340",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7ec3031d6996ef6475adcf1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "yardi",
      "external_id": "128042551",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7c9c2b67ef9ee848d6467b92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "yardi",
      "external_id": "127398783",
      "title": "Central Heat & Air",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df83221a01e64477804e3b4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "yardi",
      "external_id": "127398784",
      "title": "Fireplaces*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b53ca08d0e3448bc5b860207",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "yardi",
      "external_id": "127398785",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cd6854d8ec0d591e23ab3acd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "yardi",
      "external_id": "127398786",
      "title": "Washer & Dryer Connections*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_13c5c174d3d3d3f595ac2cc6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "yardi",
      "external_id": "127398787",
      "title": "Private Patio or Balcony*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_12142df9ca56b88b27489c1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "yardi",
      "external_id": "127398788",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aa3539efa5efcb0ab387032e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "yardi",
      "external_id": "127398789",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f1beedce587d6be2cf0fbcd5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "yardi",
      "external_id": "127398790",
      "title": "Choice of Townhome, Loft, or Apartment",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d8dd8dcd285c0cf340bf0b7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "yardi",
      "external_id": "127398791",
      "title": "Custom Cabinetry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_01ea1557-1660-4655-a950-e3516446ef3f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f1930-7cb8-7554-80ee-0b599aab1aa3.webp",
      "image_media": {
        "alt_text": "Modern community lounge with a large kitchen island, bar seating, a billiards table, and large screen TVs on a green wall.",
        "public_id": "019f1930-7cb8-7554-80ee-0b599aab1aa3",
        "storage_key": "property/6767906449165636/019f1930-7cb8-7554-80ee-0b599aab1aa3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and socialize in our modern community lounge. Enjoy the fully equipped kitchen with a spacious island, comfortable bar stools, and a billiards area perfect for game nights. Your ideal space to unwind and connect.",
      "link": "",
      "alt_text": "Modern community lounge with a large kitchen island, bar seating, a billiards table, and large screen TVs on a green wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b019e98a-8c7a-439c-a054-5b011e424630",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f1930-73d0-72bf-bd5a-77fe07c1d887.webp",
      "image_media": {
        "alt_text": "Modern resident lounge with high vaulted ceilings, exposed beams, statement chandelier, fireplace, and comfortable seating.",
        "public_id": "019f1930-73d0-72bf-bd5a-77fe07c1d887",
        "storage_key": "property/6767906449165636/019f1930-73d0-72bf-bd5a-77fe07c1d887.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Our stylish resident lounge features a grand vaulted ceiling with exposed wood beams, a modern fireplace, and elegant seating areas. It's the perfect inviting space for relaxation or social gatherings.",
      "link": "",
      "alt_text": "Modern resident lounge with high vaulted ceilings, exposed beams, statement chandelier, fireplace, and comfortable seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_95836eb2-342d-41cf-9b2a-69ba99692d76",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f1930-1dad-7668-9026-38c1521b3087.webp",
      "image_media": {
        "alt_text": "An expansive outdoor swimming pool with in-water loungers, surrounded by sun chairs, umbrellas, and apartment buildings under a blue sky.",
        "public_id": "019f1930-1dad-7668-9026-38c1521b3087",
        "storage_key": "property/6767906449165636/019f1930-1dad-7668-9026-38c1521b3087.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Dive into relaxation at our stunning community pool, complete with comfortable in-water loungers and plenty of space for sunbathing. Experience resort-style living right at home.",
      "link": "",
      "alt_text": "An expansive outdoor swimming pool with in-water loungers, surrounded by sun chairs, umbrellas, and apartment buildings under a blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9535852e-f95c-424a-ab44-24a3e9742f8f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192f-d713-71ed-8c37-ec410345de22.webp",
      "image_media": {
        "alt_text": "Exterior view of an apartment building with multiple attached garages, brick accents, and a main entrance under a blue sky.",
        "public_id": "019f192f-d713-71ed-8c37-ec410345de22",
        "storage_key": "property/6767906449165636/019f192f-d713-71ed-8c37-ec410345de22.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Experience convenience with attached garages directly accessible to your home. Our community features attractive building exteriors with modern finishes and ample parking options.",
      "link": "",
      "alt_text": "Exterior view of an apartment building with multiple attached garages, brick accents, and a main entrance under a blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fcc96670-8787-494d-aa1b-ec1885f15844",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f1930-3e55-767a-8e2d-2321c48378d6.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with two built-in grills and picnic tables, with apartment buildings in the background.",
        "public_id": "019f1930-3e55-767a-8e2d-2321c48378d6",
        "storage_key": "property/6767906449165636/019f1930-3e55-767a-8e2d-2321c48378d6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and dining at our community grilling station, perfect for social gatherings and enjoying the fresh air.",
      "link": "",
      "alt_text": "Outdoor grilling area with two built-in grills and picnic tables, with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c83bcc5c-70c9-45ab-a273-58b910db2c60",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f1930-2eb1-778f-af94-ab47242acb12.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019f1930-2eb1-778f-af94-ab47242acb12",
        "storage_key": "property/6767906449165636/019f1930-2eb1-778f-af94-ab47242acb12.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our resort-style swimming pool, perfect for relaxing and soaking up the sun. Surrounded by beautiful apartment buildings.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cb8e0977-c26a-48d5-82b3-4938c6cb2679",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f1930-361d-716d-aa61-2851c245796b.webp",
      "image_media": {
        "alt_text": "Sunny outdoor community swimming pool with a tanning ledge, umbrellas, and lounge chairs, surrounded by apartment buildings.",
        "public_id": "019f1930-361d-716d-aa61-2851c245796b",
        "storage_key": "property/6767906449165636/019f1930-361d-716d-aa61-2851c245796b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Dive into relaxation at our expansive resort-style swimming pool, featuring a tanning ledge and comfortable lounge chairs. Our inviting outdoor oasis is perfect for unwinding under the sun.",
      "link": "",
      "alt_text": "Sunny outdoor community swimming pool with a tanning ledge, umbrellas, and lounge chairs, surrounded by apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_58053116-f7ce-46bf-816f-2af0e4024a6a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f1930-4d32-7229-8d05-774cfd8f933a.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment and benches, with apartment buildings in the background.",
        "public_id": "019f1930-4d32-7229-8d05-774cfd8f933a",
        "storage_key": "property/6767906449165636/019f1930-4d32-7229-8d05-774cfd8f933a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, complete with agility equipment and comfortable seating, perfect for your furry friends to play and socialize.",
      "link": "",
      "alt_text": "Dog park with agility equipment and benches, with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_76f1b976-11d8-4f28-b48c-3035ccf649fe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192f-ce72-7448-8067-cfcd8d73b4bd.webp",
      "image_media": {
        "alt_text": "Signage for Ridge at 66 Apartment Homes.",
        "public_id": "019f192f-ce72-7448-8067-cfcd8d73b4bd",
        "storage_key": "property/6767906449165636/019f192f-ce72-7448-8067-cfcd8d73b4bd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Ridge at 66 Apartment Homes. Discover a new standard of living in this beautiful community.",
      "link": "",
      "alt_text": "Signage for Ridge at 66 Apartment Homes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5cfa620f-cd98-4dac-944a-8f478e4097df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f1930-0a7c-7370-a0d7-c21774035abf.webp",
      "image_media": {
        "alt_text": "Modern apartment buildings with a clubhouse and outdoor seating area.",
        "public_id": "019f1930-0a7c-7370-a0d7-c21774035abf",
        "storage_key": "property/6767906449165636/019f1930-0a7c-7370-a0d7-c21774035abf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Experience luxury living at our community, featuring a modern clubhouse and comfortable outdoor seating area perfect for relaxing and socializing.",
      "link": "",
      "alt_text": "Modern apartment buildings with a clubhouse and outdoor seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_57344809-3543-48c1-8ec8-a13d7d83570e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f1930-4b98-711d-89d5-09ce023c32d9.webp",
      "image_media": {
        "alt_text": "Dog park area with agility equipment and apartment buildings in the background.",
        "public_id": "019f1930-4b98-711d-89d5-09ce023c32d9",
        "storage_key": "property/6767906449165636/019f1930-4b98-711d-89d5-09ce023c32d9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our spacious dog park, perfect for your furry friends to play and socialize. Featuring agility equipment and plenty of room to run.",
      "link": "",
      "alt_text": "Dog park area with agility equipment and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5cb86150-7a3d-4513-b310-8780b5ad1f35",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f1930-2cf7-725a-a220-9ef13d36b90c.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with in-water loungers and a covered seating area.",
        "public_id": "019f1930-2cf7-725a-a220-9ef13d36b90c",
        "storage_key": "property/6767906449165636/019f1930-2cf7-725a-a220-9ef13d36b90c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, complete with in-water loungers and a shaded cabana for ultimate relaxation.",
      "link": "",
      "alt_text": "Resort-style swimming pool with in-water loungers and a covered seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0d9ab863-6048-4ac1-8f30-e4f5a83abf26",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f1930-127d-737b-bfed-421c9b748358.webp",
      "image_media": {
        "alt_text": "Exterior view of the multifamily property's main building entrance.",
        "public_id": "019f1930-127d-737b-bfed-421c9b748358",
        "storage_key": "property/6767906449165636/019f1930-127d-737b-bfed-421c9b748358.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our community! This is the main entrance to our beautifully designed building, offering a warm and inviting first impression.",
      "link": "",
      "alt_text": "Exterior view of the multifamily property's main building entrance.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7b690a9d-2de3-441b-b870-54467e006261",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192f-de08-701e-96e0-88749448b5aa.webp",
      "image_media": {
        "alt_text": "Outdoor patio area with a fire pit and seating, adjacent to a modern apartment building.",
        "public_id": "019f192f-de08-701e-96e0-88749448b5aa",
        "storage_key": "property/6767906449165636/019f192f-de08-701e-96e0-88749448b5aa.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the outdoors with friends and family around the fire pit on the spacious patio, perfect for gathering and relaxing.",
      "link": "",
      "alt_text": "Outdoor patio area with a fire pit and seating, adjacent to a modern apartment building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ce636c90-d761-43cd-861a-0da1868dcbd3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192f-f834-739e-a0f9-5d1b6539bd4b.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
        "public_id": "019f192f-f834-739e-a0f9-5d1b6539bd4b",
        "storage_key": "property/6767906449165636/019f192f-f834-739e-a0f9-5d1b6539bd4b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our sparkling outdoor swimming pool, complete with comfortable lounge chairs and beautiful views of the surrounding apartment buildings.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_25bad493-55df-4865-90b0-5cebef6c20c6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f1930-009a-742e-9cae-9349ac763f6d.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, stationary bikes, and weight racks.",
        "public_id": "019f1930-009a-742e-9cae-9349ac763f6d",
        "storage_key": "property/6767906449165636/019f1930-009a-742e-9cae-9349ac763f6d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with cardio machines and free weights.",
      "link": "",
      "alt_text": "Fitness center with treadmills, ellipticals, stationary bikes, and weight racks.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_defd2561-3d33-4f26-aad6-8b793a2fa429",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192f-4552-7112-a1aa-c7bd512207dd.webp",
      "image_media": {
        "alt_text": "Spacious community game room featuring a billiards table, multiple wall-mounted TVs, and stylish high-top seating areas.",
        "public_id": "019f192f-4552-7112-a1aa-c7bd512207dd",
        "storage_key": "property/6767906449165636/019f192f-4552-7112-a1aa-c7bd512207dd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our vibrant community game room, complete with a professional billiards table, multiple flat-screen TVs for entertainment, and cozy seating. Perfect for socializing with neighbors and friends.",
      "link": "",
      "alt_text": "Spacious community game room featuring a billiards table, multiple wall-mounted TVs, and stylish high-top seating areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_46e8f58b-ae40-4f29-937e-853baf5f4262",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192f-7bed-75bd-be13-5f264fe45cd8.webp",
      "image_media": {
        "alt_text": "Modern gym with treadmills, elliptical, stationary bike, and weight machines.",
        "public_id": "019f192f-7bed-75bd-be13-5f264fe45cd8",
        "storage_key": "property/6767906449165636/019f192f-7bed-75bd-be13-5f264fe45cd8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring cardio machines and weight training equipment for a complete workout.",
      "link": "",
      "alt_text": "Modern gym with treadmills, elliptical, stationary bike, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e466a424-d508-4370-bc05-ba8975d41c2c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192f-43f1-72f7-8ce2-6b4e59faeab5.webp",
      "image_media": {
        "alt_text": "Modern apartment gym with exercise balls, weights, treadmills, and weight machines.",
        "public_id": "019f192f-43f1-72f7-8ce2-6b4e59faeab5",
        "storage_key": "property/6767906449165636/019f192f-43f1-72f7-8ce2-6b4e59faeab5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines, weight training equipment, and free weights.",
      "link": "",
      "alt_text": "Modern apartment gym with exercise balls, weights, treadmills, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_697afac5-d6a3-4e8a-b990-1d7966f5ea28",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192d-e196-75bd-b9f3-69c2c87feb7c.webp",
      "image_media": {
        "alt_text": "Stylish apartment bathroom with a dark wood vanity, single sink, large mirror, modern lighting, and a white toilet.",
        "public_id": "019f192d-e196-75bd-b9f3-69c2c87feb7c",
        "storage_key": "property/6767906449165636/019f192d-e196-75bd-b9f3-69c2c87feb7c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy the convenience and elegance of our apartment bathrooms, featuring dark wood cabinetry, spacious countertops, and contemporary fixtures for a sophisticated experience.",
      "link": "",
      "alt_text": "Stylish apartment bathroom with a dark wood vanity, single sink, large mirror, modern lighting, and a white toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4c53228a-87c1-40b6-836d-198e6799075f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192d-e1bf-7027-800b-f6d99def2665.webp",
      "image_media": {
        "alt_text": "A modern bedroom with a dark wooden bed frame, light bedding, a ceiling fan, a dresser, and a window with blinds.",
        "public_id": "019f192d-e1bf-7027-800b-f6d99def2665",
        "storage_key": "property/6767906449165636/019f192d-e1bf-7027-800b-f6d99def2665.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Discover comfort in our stylish bedrooms, featuring plush carpeting, elegant dark wood furnishings, and a refreshing ceiling fan for a relaxing retreat.",
      "link": "",
      "alt_text": "A modern bedroom with a dark wooden bed frame, light bedding, a ceiling fan, a dresser, and a window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_76c2ebef-426f-4648-a723-96c5e36f7121",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192d-d6fa-7329-b55d-3f4b91971ad9.webp",
      "image_media": {
        "alt_text": "Modern bathroom with dark wood vanity, white marble-look countertop, large mirror, shower-tub combo, and tiled floor.",
        "public_id": "019f192d-d6fa-7329-b55d-3f4b91971ad9",
        "storage_key": "property/6767906449165636/019f192d-d6fa-7329-b55d-3f4b91971ad9.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy the convenience and style of a contemporary bathroom featuring spacious vanity storage, a clean shower/tub combination, and elegant finishes for your daily routine.",
      "link": "",
      "alt_text": "Modern bathroom with dark wood vanity, white marble-look countertop, large mirror, shower-tub combo, and tiled floor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0c18b732-81b5-4fcc-9b34-0193cfebf41f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192d-a2c2-77af-9cc8-cc6654952b41.webp",
      "image_media": {
        "alt_text": "A modern apartment kitchen with white cabinets, stainless steel appliances, a marble-top island with bar stools, and a glimpse of a bedroom.",
        "public_id": "019f192d-a2c2-77af-9cc8-cc6654952b41",
        "storage_key": "property/6767906449165636/019f192d-a2c2-77af-9cc8-cc6654952b41.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Discover modern living in our spacious apartments, featuring a fully equipped kitchen with contemporary finishes and a seamless flow into a comfortable bedroom.",
      "link": "",
      "alt_text": "A modern apartment kitchen with white cabinets, stainless steel appliances, a marble-top island with bar stools, and a glimpse of a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_892b8aef-fc0a-47e5-a097-ad9fee3f55a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192d-cd19-735e-92be-44845b1d0578.webp",
      "image_media": {
        "alt_text": "Modern dining area with a dark wood table, four upholstered chairs, and decorative wall art.",
        "public_id": "019f192d-cd19-735e-92be-44845b1d0578",
        "storage_key": "property/6767906449165636/019f192d-cd19-735e-92be-44845b1d0578.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A sophisticated dining space featuring a dark wood table, comfortable upholstered chairs, and stylish wall decor, perfect for entertaining guests.",
      "link": "",
      "alt_text": "Modern dining area with a dark wood table, four upholstered chairs, and decorative wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f9b46d0f-2ff9-44cd-9b55-9dee54ee3955",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192d-dd97-7579-9a0b-a99a7c3dcffe.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-sized bed, dresser, mirror, and ceiling fan.",
        "public_id": "019f192d-dd97-7579-9a0b-a99a7c3dcffe",
        "storage_key": "property/6767906449165636/019f192d-dd97-7579-9a0b-a99a7c3dcffe.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-sized bed, elegant dresser with mirror, and a modern ceiling fan for added comfort.",
      "link": "",
      "alt_text": "Bedroom with a king-sized bed, dresser, mirror, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c2851124-1294-448b-b4e4-ce367bea702b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192d-8470-7029-bc19-e3c891625de1.webp",
      "image_media": {
        "alt_text": "Bathroom with a vanity, toilet, and shower with a checkered curtain.",
        "public_id": "019f192d-8470-7029-bc19-e3c891625de1",
        "storage_key": "property/6767906449165636/019f192d-8470-7029-bc19-e3c891625de1.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Renovated bathroom featuring a double vanity with marble countertops, a modern toilet, and a shower with a stylish checkered curtain.",
      "link": "",
      "alt_text": "Bathroom with a vanity, toilet, and shower with a checkered curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bdb1e390-93ea-4f28-8cb7-69bbba86965d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192d-d0b6-746f-a45f-5fab7eae78ce.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a large island.",
        "public_id": "019f192d-d0b6-746f-a45f-5fab7eae78ce",
        "storage_key": "property/6767906449165636/019f192d-d0b6-746f-a45f-5fab7eae78ce.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed kitchen featuring rich dark wood cabinetry, sleek stainless steel appliances, and a spacious island perfect for meal prep and casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a large island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c8da2eb5-e8f4-4607-a388-e9eb283744c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192d-a5ac-7566-9116-1c0452e863ce.webp",
      "image_media": {
        "alt_text": "Desk and dining area in an apartment with large windows and modern decor.",
        "public_id": "019f192d-a5ac-7566-9116-1c0452e863ce",
        "storage_key": "property/6767906449165636/019f192d-a5ac-7566-9116-1c0452e863ce.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Create your ideal workspace or enjoy meals in this versatile dining and desk area, bathed in natural light from large windows.",
      "link": "",
      "alt_text": "Desk and dining area in an apartment with large windows and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2ba1ab9f-0541-478c-855e-d2b878c171d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192d-8608-741a-83c7-f6447f0e9148.webp",
      "image_media": {
        "alt_text": "Spacious bedroom with a king-size bed, nightstand, dresser, and ceiling fan.",
        "public_id": "019f192d-8608-741a-83c7-f6447f0e9148",
        "storage_key": "property/6767906449165636/019f192d-8608-741a-83c7-f6447f0e9148.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Discover comfort and style in this beautifully appointed bedroom, featuring a plush king-size bed, elegant nightstand, and a spacious dresser.",
      "link": "",
      "alt_text": "Spacious bedroom with a king-size bed, nightstand, dresser, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b020aca9-c3da-40bf-9177-e6fbdaae4c27",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192d-c91e-7729-bca4-7369fb8b5fc5.webp",
      "image_media": {
        "alt_text": "Stylish living room and dining area with a sectional sofa, coffee table, and dining set.",
        "public_id": "019f192d-c91e-7729-bca4-7369fb8b5fc5",
        "storage_key": "property/6767906449165636/019f192d-c91e-7729-bca4-7369fb8b5fc5.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Expansive living and dining space featuring a comfortable sectional sofa, modern coffee table, and elegant dining set, perfect for entertaining.",
      "link": "",
      "alt_text": "Stylish living room and dining area with a sectional sofa, coffee table, and dining set.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_94153244-bf25-4162-8912-3ec51aa9f288",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192d-b6ee-76a8-b485-96f148f3c0cc.webp",
      "image_media": {
        "alt_text": "Bathroom with white vanity, marble countertop, sink, toilet, and shower with curtain.",
        "public_id": "019f192d-b6ee-76a8-b485-96f148f3c0cc",
        "storage_key": "property/6767906449165636/019f192d-b6ee-76a8-b485-96f148f3c0cc.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Refresh and unwind in a modern bathroom featuring a spacious vanity, marble countertops, and a shower-tub combination.",
      "link": "",
      "alt_text": "Bathroom with white vanity, marble countertop, sink, toilet, and shower with curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fb2c1017-c456-4e2e-a5f1-4c6c44e7eec2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192d-7058-759a-9352-b635f1d9dff6.webp",
      "image_media": {
        "alt_text": "A modern apartment study area with a light wood desk, white boucle chair, wicker floor lamp, and abstract art. A bathroom is visible through the doorway.",
        "public_id": "019f192d-7058-759a-9352-b635f1d9dff6",
        "storage_key": "property/6767906449165636/019f192d-7058-759a-9352-b635f1d9dff6.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "This versatile space offers a perfect spot for working or studying from home, featuring stylish decor and easy access to the adjacent bathroom. Experience comfort and convenience in your apartment.",
      "link": "",
      "alt_text": "A modern apartment study area with a light wood desk, white boucle chair, wicker floor lamp, and abstract art. A bathroom is visible through the doorway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cc3cce54-25ab-4db7-b8e1-6e1ca1b9847a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192d-6842-750d-befc-1dafa8faef99.webp",
      "image_media": {
        "alt_text": "Modern dining area with a round white table, four upholstered chairs, and large windows with macrame curtains.",
        "public_id": "019f192d-6842-750d-befc-1dafa8faef99",
        "storage_key": "property/6767906449165636/019f192d-6842-750d-befc-1dafa8faef99.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy stylish and comfortable dining in this modern apartment, featuring a round table, plush seating, and abundant natural light.",
      "link": "",
      "alt_text": "Modern dining area with a round white table, four upholstered chairs, and large windows with macrame curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cc8cdc39-f977-44d5-a1d1-26b64f5c4b12",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192d-baa5-7378-94d8-282c0c76b4c5.webp",
      "image_media": {
        "alt_text": "A well-lit bedroom with a queen-size bed, dresser, and nightstand.",
        "public_id": "019f192d-baa5-7378-94d8-282c0c76b4c5",
        "storage_key": "property/6767906449165636/019f192d-baa5-7378-94d8-282c0c76b4c5.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "This inviting bedroom features a comfortable queen-size bed, a stylish dresser, and a modern nightstand. Perfect for relaxation and a good night's sleep.",
      "link": "",
      "alt_text": "A well-lit bedroom with a queen-size bed, dresser, and nightstand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8091148c-f74e-4a9a-8235-b439d6e82704",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192d-03e6-75a7-810d-555908704b8e.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with a green door numbered 522 and a welcome mat.",
        "public_id": "019f192d-03e6-75a7-810d-555908704b8e",
        "storage_key": "property/6767906449165636/019f192d-03e6-75a7-810d-555908704b8e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "This image shows the exterior of an apartment building, highlighting the entrance to unit 522. The green door is a focal point, with a welcome mat at its base. The surrounding area features wooden planks for the walkway and siding on the building.",
      "link": "",
      "alt_text": "Apartment building exterior with a green door numbered 522 and a welcome mat.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0848daf0-a45d-4e1e-83d3-3584bbe3a525",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192d-a563-754a-9d3e-eeff05362a77.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and four chairs.",
        "public_id": "019f192d-a563-754a-9d3e-eeff05362a77",
        "storage_key": "property/6767906449165636/019f192d-a563-754a-9d3e-eeff05362a77.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy meals in this bright and airy dining area, perfect for intimate gatherings or everyday dining.",
      "link": "",
      "alt_text": "Dining area with a round table and four chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b5a5a0f7-4fb3-482c-b8d5-a3fbd68e49ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192d-28d6-738d-9098-35c1ad1bcff8.webp",
      "image_media": {
        "alt_text": "Spacious living room with a brown leather sofa, green armchair, coffee table, fireplace, TV, and breakfast bar.",
        "public_id": "019f192d-28d6-738d-9098-35c1ad1bcff8",
        "storage_key": "property/6767906449165636/019f192d-28d6-738d-9098-35c1ad1bcff8.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Experience comfort in your apartment living room, complete with a cozy fireplace, modern fixtures, a breakfast bar, and large windows.",
      "link": "",
      "alt_text": "Spacious living room with a brown leather sofa, green armchair, coffee table, fireplace, TV, and breakfast bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_19c305f4-e81f-41f4-9a2f-838be9941ea6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192d-2678-7451-8299-284e9033787f.webp",
      "image_media": {
        "alt_text": "A modern apartment kitchen featuring dark wood cabinets, stainless steel appliances, a white subway tile backsplash, and a marble-look island with two bar stools.",
        "public_id": "019f192d-2678-7451-8299-284e9033787f",
        "storage_key": "property/6767906449165636/019f192d-2678-7451-8299-284e9033787f.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Discover modern living in our spacious apartment kitchens, complete with elegant dark wood cabinetry, stainless steel appliances, a stylish island, and plenty of counter space for cooking and entertaining.",
      "link": "",
      "alt_text": "A modern apartment kitchen featuring dark wood cabinets, stainless steel appliances, a white subway tile backsplash, and a marble-look island with two bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dcfcc56e-9b70-4017-9626-72ba2b488623",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192d-3c69-714a-acfc-85106992ee26.webp",
      "image_media": {
        "alt_text": "Bright and spacious apartment living room with a white sofa, a wooden coffee table, a pink armchair, and a desk area. Large windows offer natural light.",
        "public_id": "019f192d-3c69-714a-acfc-85106992ee26",
        "storage_key": "property/6767906449165636/019f192d-3c69-714a-acfc-85106992ee26.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Discover the comfort and style of our thoughtfully designed living spaces. This bright apartment features ample natural light, soft carpeting, and versatile areas for relaxation and work, perfect for modern living.",
      "link": "",
      "alt_text": "Bright and spacious apartment living room with a white sofa, a wooden coffee table, a pink armchair, and a desk area. Large windows offer natural light.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_18c1a492-da06-4739-b7fd-91b6ad1ddb57",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192d-72ff-73fa-be78-f7fc0a08a87a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry.",
        "public_id": "019f192d-72ff-73fa-be78-f7fc0a08a87a",
        "storage_key": "property/6767906449165636/019f192d-72ff-73fa-be78-f7fc0a08a87a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "View of a spacious, modern kitchen featuring sleek white cabinets, stainless steel appliances including a microwave, oven, and dishwasher, and a granite countertop.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0baf7932-40b5-421e-94bc-1e01a6b5429e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192d-0aee-7421-936f-2cd749dbebb8.webp",
      "image_media": {
        "alt_text": "Spacious apartment living room and dining area with modern furnishings, large windows, and grey carpet.",
        "public_id": "019f192d-0aee-7421-936f-2cd749dbebb8",
        "storage_key": "property/6767906449165636/019f192d-0aee-7421-936f-2cd749dbebb8.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Relax in your spacious living room, perfect for entertaining or unwinding after a long day. Our open-concept layouts offer style and comfort.",
      "link": "",
      "alt_text": "Spacious apartment living room and dining area with modern furnishings, large windows, and grey carpet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_1320b1df-cb69-46ea-8cab-3ab4f67d332b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "6200 SW 3rd St, Oklahoma City, OK 73128, USA",
      "poi_short_description": "Relaxed chain steakhouse serving cuts of beef, ribs and other down-to-earth fare.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and rolls. They also highlight the fast service, friendly staff, and reasonable prices.\n\nSome reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-9824-77b8-83ab-3e5ed47d2428.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9824-77b8-83ab-3e5ed47d2428",
        "storage_key": "property/6767906449165636/019d2709-9824-77b8-83ab-3e5ed47d2428.webp",
        "width": 1076,
        "height": 724
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/oklahoma-city-west-sw-3rd-st?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=12279087547535667782&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "35.4609531",
      "poi_longitude": "-97.6232978",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-789-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-cdfa-71ec-b4d3-98be1ebe8a4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-cdfa-71ec-b4d3-98be1ebe8a4f",
        "storage_key": "property/6767906449165636/019d2709-cdfa-71ec-b4d3-98be1ebe8a4f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdwTj7s0PsocRRjLJLBEVaKo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_b239cecf-8c7a-441a-a598-4f9b8d33c635",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Golden Corral Buffet & Grill",
      "poi_type": "Restaurants",
      "poi_address": "520 S MacArthur Blvd, Oklahoma City, OK 73128, USA",
      "poi_short_description": "Family chain featuring an all-you-can-eat buffet of meat and seafood staples, plus a salad bar and a dessert selection.",
      "poi_long_description": "Diners say this buffet restaurant offers a wide variety of fresh and delicious food, including steak, chicken, ham, baked beans, mac and cheese, green beans, fried chicken, Salisbury steak, rolls, and honey butter cornbread. They also highlight the attentive and friendly service, with many reviewers praising specific servers for their exceptional service.\n\nSome reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-97b1-72ff-99ec-317aa6e86c85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-97b1-72ff-99ec-317aa6e86c85",
        "storage_key": "property/6767906449165636/019d2709-97b1-72ff-99ec-317aa6e86c85.webp",
        "width": 960,
        "height": 639
      },
      "poi_business_url": "https://www.goldencorral.com/locations/913/golden-corral-s-macarthur-blvd?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=913",
      "poi_directions_map_url": "https://maps.google.com/?cid=4595961913688049149&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golden-corral-buffet--grill",
      "poi_latitude": "35.4609499",
      "poi_longitude": "-97.6168342",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-949-9991",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-cdfa-71ec-b4d3-98be1ebe8a4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-cdfa-71ec-b4d3-98be1ebe8a4f",
        "storage_key": "property/6767906449165636/019d2709-cdfa-71ec-b4d3-98be1ebe8a4f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdxWs29MPsocR_cWZkgIjyD8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_792b8ed5-8708-4984-9fa8-52f570d846d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "6330 SW 3rd St, Oklahoma City, OK 73128, USA",
      "poi_short_description": "Family-friendly chain restaurant known for unlimited soup, salad, and breadsticks.",
      "poi_long_description": "People say this Italian restaurant serves delicious pasta, soup, salad, and breadsticks. They also highlight the fast and friendly service, and the attentive staff.\n\nOther reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-9914-74fe-bb40-1e91d5769017.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9914-74fe-bb40-1e91d5769017",
        "storage_key": "property/6767906449165636/019d2709-9914-74fe-bb40-1e91d5769017.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olivegarden.com/locations/ok/oklahoma-city/westgate-marketplace/4444?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:oklahoma-city-ok-4444_pl:locurl_rd:1785",
      "poi_directions_map_url": "https://maps.google.com/?cid=12446364743026005606&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "35.46141679999999",
      "poi_longitude": "-97.6257249",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-440-0345",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-cdfa-71ec-b4d3-98be1ebe8a4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-cdfa-71ec-b4d3-98be1ebe8a4f",
        "storage_key": "property/6767906449165636/019d2709-cdfa-71ec-b4d3-98be1ebe8a4f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5bwMnc4PsocRZtYCRcpeuqw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_b0f1901c-fa38-468b-9b97-696dcfebe4e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Mariscos El General - Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "4559 NW 23rd St, Oklahoma City, OK 73127, USA",
      "poi_short_description": "Live music and lively restaurant featuring seafood dishes, along with a full bar of cocktails, beer, and wine.",
      "poi_long_description": "People say this seafood restaurant serves delicious aguachiles, ceviche, and octopus. They highlight the generous portions, fresh ingredients, and flavorful dishes. They also like the attentive and friendly staff, and the lively atmosphere with live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-9807-700a-a3de-22584433ffde.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9807-700a-a3de-22584433ffde",
        "storage_key": "property/6767906449165636/019d2709-9807-700a-a3de-22584433ffde.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "https://mariscoselgeneraloklahomacity.shop/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9041095668201211933&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mariscos-el-general---oklahoma-city",
      "poi_latitude": "35.4947375",
      "poi_longitude": "-97.6033184",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-283-2430",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-cdfa-71ec-b4d3-98be1ebe8a4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-cdfa-71ec-b4d3-98be1ebe8a4f",
        "storage_key": "property/6767906449165636/019d2709-cdfa-71ec-b4d3-98be1ebe8a4f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJyUIWCmMRsocRHch0w5tseH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_8684ac06-144b-41c2-8e75-b9f14d97eb19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Oklahoma City Incredible Pizza Company",
      "poi_type": "Restaurants",
      "poi_address": "5833 Northwest Expy, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Buffet dining as well as an arcade, laser tag arena and go-karts for kids' parties and other fun days out.",
      "poi_long_description": "Visitors say this pizza restaurant offers a buffet with a variety of food, including pizza, hot dogs, tacos, chicken, and a salad bar, as well as fun attractions like go-karts and laser tag. They like the friendly and helpful staff, the clean facilities, and the great value for families, with many mentioning it's a popular spot for birthday parties.\n\nSome reviews mention the buffet can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-9c2c-756e-95d3-5ad9f4cf90db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9c2c-756e-95d3-5ad9f4cf90db",
        "storage_key": "property/6767906449165636/019d2709-9c2c-756e-95d3-5ad9f4cf90db.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://incrediblepizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7640346941500558065&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-city-incredible-pizza-company",
      "poi_latitude": "35.5504818",
      "poi_longitude": "-97.6162357",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-728-8360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-cdfa-71ec-b4d3-98be1ebe8a4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-cdfa-71ec-b4d3-98be1ebe8a4f",
        "storage_key": "property/6767906449165636/019d2709-cdfa-71ec-b4d3-98be1ebe8a4f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ30Sq7dMEsocR8QriIBD3B2o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_450f1480-3835-4639-9f1c-bd9cee1a6451",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "OKC Outlets",
      "poi_type": "Shopping & Retail",
      "poi_address": "7624 W Reno Ave Suite 380, Oklahoma City, OK 73127, USA",
      "poi_short_description": "Relaxed outdoor mall featuring more than 70 brand-name designer stores of shoes, clothing and more.",
      "poi_long_description": "People say this outlet mall offers a wide variety of stores and good deals. They also highlight the friendly staff and nice shopping experience.\n\nOther reviews mention the food court can have limited options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-9cc7-736a-939e-be18b0eb525f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9cc7-736a-939e-be18b0eb525f",
        "storage_key": "property/6767906449165636/019d2709-9cc7-736a-939e-be18b0eb525f.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.okcoutlets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1773095145334850603&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "okc-outlets",
      "poi_latitude": "35.4625898",
      "poi_longitude": "-97.6473972",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-787-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-cdf6-75bc-a6fe-56e1fd47b104.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-cdf6-75bc-a6fe-56e1fd47b104",
        "storage_key": "property/6767906449165636/019d2709-cdf6-75bc-a6fe-56e1fd47b104.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJdWyLw68PsocRK0Sn8qNMmxg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_03f20a7a-0790-4d03-ba72-cc65957f62dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Feria Latina Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "4909 NW 23rd St, Oklahoma City, OK 73127, USA",
      "poi_short_description": "Latino grocery and food store featuring fresh produce and a bakery.",
      "poi_long_description": "People say this supermarket offers fresh produce and delicious bakery items. They also highlight the reasonable prices on marinated meats and the convenient on-site restaurant.\n\nOther reviews mention the parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-9cc4-712b-bfa2-4b6c3a231f6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9cc4-712b-bfa2-4b6c3a231f6a",
        "storage_key": "property/6767906449165636/019d2709-9cc4-712b-bfa2-4b6c3a231f6a.webp",
        "width": 949,
        "height": 1265
      },
      "poi_business_url": "http://www.laferialatina.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7639629429527723566&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "feria-latina-supermarket",
      "poi_latitude": "35.4938889",
      "poi_longitude": "-97.6113889",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-606-4004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-cdc7-76be-8c15-a49560ce7f96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-cdc7-76be-8c15-a49560ce7f96",
        "storage_key": "property/6767906449165636/019d2709-cdc7-76be-8c15-a49560ce7f96.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm6vpcQIQsocRLr6eWn1qBWo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_673c0573-cc5f-45f8-8cef-8a89a9031560",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "6800 W Reno Ave, Oklahoma City, OK 73127, USA",
      "poi_short_description": "Home improvement chain stocking a range of tools, appliances, lighting, paint, and flooring.",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-9dfa-7189-bd76-b7a15bbf9416.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9dfa-7189-bd76-b7a15bbf9416",
        "storage_key": "property/6767906449165636/019d2709-9dfa-7189-bd76-b7a15bbf9416.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/W-Oklahoma-City/OK/Oklahoma-City/73127/3908?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=4879427188602399743&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "35.4634233",
      "poi_longitude": "-97.6319266",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-789-3895",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-cdf6-75bc-a6fe-56e1fd47b104.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-cdf6-75bc-a6fe-56e1fd47b104",
        "storage_key": "property/6767906449165636/019d2709-cdf6-75bc-a6fe-56e1fd47b104.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJBRp1xskPsocR_2sH_Cw1t0M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_30456ae2-b957-402b-a646-58e34faae3cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Crest Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "715 N Czech Hall Rd, Yukon, OK 73099, USA",
      "poi_short_description": "Large, clean grocery store offering a deli, butcher shop, meat counter and bakery that operates 24/7.",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, meats, deli items, premade items, sushi, and bakery goods. They highlight the reasonable prices, clean and well-organized store, and wide aisles. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-a100-717e-9bfc-814e2a5775d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a100-717e-9bfc-814e2a5775d1",
        "storage_key": "property/6767906449165636/019d2709-a100-717e-9bfc-814e2a5775d1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.crestfoodsok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4133772343963612855&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crest-foods",
      "poi_latitude": "35.4736012",
      "poi_longitude": "-97.7462437",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-805-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-cdc7-76be-8c15-a49560ce7f96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-cdc7-76be-8c15-a49560ce7f96",
        "storage_key": "property/6767906449165636/019d2709-cdc7-76be-8c15-a49560ce7f96.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq_53UKUJsocRt_ZIkAscXjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_628a8816-be84-42e0-bec5-e43b1c4e6db5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Southern Nazarene University",
      "poi_type": "Education",
      "poi_address": "6729 NW 39th Expy, Bethany, OK 73008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-a14f-77eb-98b8-83a998799b2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a14f-77eb-98b8-83a998799b2b",
        "storage_key": "property/6767906449165636/019d2709-a14f-77eb-98b8-83a998799b2b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.snu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2990625230431240297&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southern-nazarene-university",
      "poi_latitude": "35.5135594",
      "poi_longitude": "-97.6288124",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-789-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-cebd-703a-a252-73c80e422ebb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-cebd-703a-a252-73c80e422ebb",
        "storage_key": "property/6767906449165636/019d2709-cebd-703a-a252-73c80e422ebb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHYsS70IFsocRacAsVM3VgCk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f055c5f3-53dc-492c-9b1e-60aa89937d6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Bethany Library - Metropolitan Library System",
      "poi_type": "Education",
      "poi_address": "6700 NW 35th St, Bethany, OK 73008, USA",
      "poi_short_description": "Public library offering kid-friendly activities, meeting rooms, and other resources.",
      "poi_long_description": "People say this public library offers a diverse selection of books and a variety of activities for all ages. They highlight the cozy atmosphere and the availability of meeting rooms. They also like the helpful and attentive staff. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-a1f7-723d-8e5d-2e94dd8cfb67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a1f7-723d-8e5d-2e94dd8cfb67",
        "storage_key": "property/6767906449165636/019d2709-a1f7-723d-8e5d-2e94dd8cfb67.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.metrolibrary.org/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=15531442417609680617&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bethany-library---metropolitan-library-system",
      "poi_latitude": "35.5062789",
      "poi_longitude": "-97.6316452",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-789-8363",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-cebd-703a-a252-73c80e422ebb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-cebd-703a-a252-73c80e422ebb",
        "storage_key": "property/6767906449165636/019d2709-cebd-703a-a252-73c80e422ebb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV4NBRVwFsocR6SYP95bEitc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_0ae92d88-03cc-4d1c-9475-2950b68f10f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Heartland Baptist Bible College",
      "poi_type": "Education",
      "poi_address": "4700 NW 10th St, Oklahoma City, OK 73127, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-a2a4-71eb-b64c-5da06e358fbd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a2a4-71eb-b64c-5da06e358fbd",
        "storage_key": "property/6767906449165636/019d2709-a2a4-71eb-b64c-5da06e358fbd.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.heartlandbaptist.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4259418941410825596&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "heartland-baptist-bible-college",
      "poi_latitude": "35.4770584",
      "poi_longitude": "-97.6066436",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-943-9330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-cebd-703a-a252-73c80e422ebb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-cebd-703a-a252-73c80e422ebb",
        "storage_key": "property/6767906449165636/019d2709-cebd-703a-a252-73c80e422ebb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJlWGkiSEQsocRfNVcuPV-HDs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d8e2ec44-44fe-4dfb-8311-dbc88993ed5c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Southwestern Christian University",
      "poi_type": "Education",
      "poi_address": "7210 NW 39th Expy, Bethany, OK 73008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-a647-763d-b6af-a7befdc5a384.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a647-763d-b6af-a7befdc5a384",
        "storage_key": "property/6767906449165636/019d2709-a647-763d-b6af-a7befdc5a384.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "http://www.swcu.edu",
      "poi_directions_map_url": "https://maps.google.com/?cid=6939619905505591377&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southwestern-christian-university",
      "poi_latitude": "35.5120221",
      "poi_longitude": "-97.6398185",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-789-7661",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-cebd-703a-a252-73c80e422ebb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-cebd-703a-a252-73c80e422ebb",
        "storage_key": "property/6767906449165636/019d2709-cebd-703a-a252-73c80e422ebb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAzjOyG4FsocRUQDkT4l7TmA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_912fd365-4754-4316-b4a8-0edf361415e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "SNU Football Stadium",
      "poi_type": "Entertainment",
      "poi_address": "Bethany, OK 73008, USA",
      "poi_short_description": "Stadium offering a field and a restroom.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-a6d3-769a-8e80-865de65c5147.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a6d3-769a-8e80-865de65c5147",
        "storage_key": "property/6767906449165636/019d2709-a6d3-769a-8e80-865de65c5147.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://snuathletics.com/facilities/snu-football-stadium/1",
      "poi_directions_map_url": "https://maps.google.com/?cid=14871021148287990153&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "snu-football-stadium",
      "poi_latitude": "35.5210386",
      "poi_longitude": "-97.661832",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-d276-75f4-b028-d6dcbdf06abf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d276-75f4-b028-d6dcbdf06abf",
        "storage_key": "property/6767906449165636/019d2709-d276-75f4-b028-d6dcbdf06abf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFyihiaEFsocRifkGv_F6YM4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_7335d4d3-ae85-4395-aaad-1bb92a6210a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Lake Overholser Iron Bridge",
      "poi_type": "Entertainment",
      "poi_address": "8703-8709 Overholser Dr, Bethany, OK 73008, USA",
      "poi_short_description": "Historic bridge on the former Route 66, still open to traffic, with scenic views.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-a811-74d8-8f2d-e54d0b23afbb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a811-74d8-8f2d-e54d0b23afbb",
        "storage_key": "property/6767906449165636/019d2709-a811-74d8-8f2d-e54d0b23afbb.webp",
        "width": 720,
        "height": 491
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1592759798430792050&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lake-overholser-iron-bridge",
      "poi_latitude": "35.5146149",
      "poi_longitude": "-97.6638523",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-d264-74ce-b500-1b5689675993.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d264-74ce-b500-1b5689675993",
        "storage_key": "property/6767906449165636/019d2709-d264-74ce-b500-1b5689675993.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlQwMnJkFsocRcnn9DZmeGhY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_11f7ec57-2c61-4dfe-bc1d-3bfe7a1cfb8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Oklahoma Museum of Flying",
      "poi_type": "Entertainment",
      "poi_address": "7110 Millionaire Dr, Bethany, OK 73008, USA",
      "poi_short_description": "Volunteer-powered locale for seeing and touching real planes plus learning about their history and mechanics.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-a814-704c-a120-68892eb989e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a814-704c-a120-68892eb989e2",
        "storage_key": "property/6767906449165636/019d2709-a814-704c-a120-68892eb989e2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/oklahomamuseumofflying/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7234880537762503548&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-museum-of-flying",
      "poi_latitude": "35.5337967",
      "poi_longitude": "-97.6380221",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-d31f-7394-8996-aff9f15c1161.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d31f-7394-8996-aff9f15c1161",
        "storage_key": "property/6767906449165636/019d2709-d31f-7394-8996-aff9f15c1161.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5c3VjhkFsocRfJu4XYR1Z2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_eb8cfb80-6bad-48aa-945c-ced252daf5c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "FUNBOX OKC",
      "poi_type": "Entertainment",
      "poi_address": "7624 W Reno Ave, Oklahoma City, OK 73127, USA",
      "poi_short_description": "Amusement park with an obstacle course, ninja wall, and other attractions, plus a playground.",
      "poi_long_description": "People say this amusement park offers a variety of bounce houses and is fun for kids and families. They highlight the clean environment and the reasonable cost. They also like the friendly and professional staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-ab3e-7195-a4ac-a2b50de71eec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-ab3e-7195-a4ac-a2b50de71eec",
        "storage_key": "property/6767906449165636/019d2709-ab3e-7195-a4ac-a2b50de71eec.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://funbox.com/okc",
      "poi_directions_map_url": "https://maps.google.com/?cid=13601958894721549338&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "funbox-okc",
      "poi_latitude": "35.4633477",
      "poi_longitude": "-97.6463812",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-455-4597",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-d264-74ce-b500-1b5689675993.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d264-74ce-b500-1b5689675993",
        "storage_key": "property/6767906449165636/019d2709-d264-74ce-b500-1b5689675993.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvSZggr4dsocRGsRXaYzdw7w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_2d5cb9be-ee0a-46f4-a0a5-a87df9273911",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Freedom Trail Park Splash Pad",
      "poi_type": "Entertainment",
      "poi_address": "Yukon, OK 73099, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-ab6d-77dd-ba5e-8b02a65af8b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-ab6d-77dd-ba5e-8b02a65af8b8",
        "storage_key": "property/6767906449165636/019d2709-ab6d-77dd-ba5e-8b02a65af8b8.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.yukonok.gov/483/Freedom-Trail-Splash-Pad",
      "poi_directions_map_url": "https://maps.google.com/?cid=9436248172752489266&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "freedom-trail-park-splash-pad",
      "poi_latitude": "35.4850487",
      "poi_longitude": "-97.7508791",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-350-8937",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-d264-74ce-b500-1b5689675993.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d264-74ce-b500-1b5689675993",
        "storage_key": "property/6767906449165636/019d2709-d264-74ce-b500-1b5689675993.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXwAFUQAJsocRMktXvbdJ9II",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_01142f2b-87ca-4492-a1d6-e7a7077bcf3d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Neel Veterinary Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2700 N MacArthur Blvd, Oklahoma City, OK 73127, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-add3-77b8-8ed6-752db36eb321.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-add3-77b8-8ed6-752db36eb321",
        "storage_key": "property/6767906449165636/019d2709-add3-77b8-8ed6-752db36eb321.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://neel.vet/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4132737864806100553&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "neel-veterinary-hospital",
      "poi_latitude": "35.4972708",
      "poi_longitude": "-97.6183664",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-947-8387",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-d264-74ce-b500-1b5689675993.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d264-74ce-b500-1b5689675993",
        "storage_key": "property/6767906449165636/019d2709-d264-74ce-b500-1b5689675993.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYV66BPkPsocRSe6SHTFvWjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_88200214-9738-4685-9494-efbb2fa350c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Crunch Fitness - Yukon",
      "poi_type": "Health and Wellness",
      "poi_address": "11241 W Reno Ave, Yukon, OK 73099, USA",
      "poi_short_description": "Gym providing month-to-month memberships, group fitness classes, cardio equipment, and more.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-ae7d-702a-b722-83eabbcecfa8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-ae7d-702a-b722-83eabbcecfa8",
        "storage_key": "property/6767906449165636/019d2709-ae7d-702a-b722-83eabbcecfa8.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.crunch.com/locations/yukon",
      "poi_directions_map_url": "https://maps.google.com/?cid=6604966592399683600&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---yukon",
      "poi_latitude": "35.4650598",
      "poi_longitude": "-97.7227318",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-265-9145",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-d264-74ce-b500-1b5689675993.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d264-74ce-b500-1b5689675993",
        "storage_key": "property/6767906449165636/019d2709-d264-74ce-b500-1b5689675993.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwSZj-PcJsocREDBOBR-OqVs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_862a4f0c-9084-4145-8b56-7787b48ea13e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1101 Garth Brooks Blvd, Yukon, OK 73099, USA",
      "poi_short_description": "Chain fitness center offering a variety of equipment, massage beds, and tanning services.",
      "poi_long_description": "People say this gym offers a wide variety of cardio and resistance training equipment, and the facilities are clean and well-maintained. They also highlight the friendly and helpful staff, and the positive and welcoming vibe.\n\nSome reviews mention the equipment can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-afea-753f-ae9d-ada36f635b40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-afea-753f-ae9d-ada36f635b40",
        "storage_key": "property/6767906449165636/019d2709-afea-753f-ae9d-ada36f635b40.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/yukon-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=711117955316607878&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.4928286",
      "poi_longitude": "-97.758255",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-350-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-d264-74ce-b500-1b5689675993.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d264-74ce-b500-1b5689675993",
        "storage_key": "property/6767906449165636/019d2709-d264-74ce-b500-1b5689675993.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjZfxNtwHsocRhmsMQANm3gk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_cfb6cb09-66a8-49b5-830c-0969104daf9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Crunch Fitness - OKC Northwest",
      "poi_type": "Health and Wellness",
      "poi_address": "8490 Northwest Expy, Oklahoma City, OK 73162, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including free weights, weight machines, and tanning beds, and provides childcare services.\n\nOther reviews mention the music can be loud and the cancellation policy can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-b084-7294-bb02-11f20a4f8539.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b084-7294-bb02-11f20a4f8539",
        "storage_key": "property/6767906449165636/019d2709-b084-7294-bb02-11f20a4f8539.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/okc-northwest",
      "poi_directions_map_url": "https://maps.google.com/?cid=6916258324870179385&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---okc-northwest",
      "poi_latitude": "35.56632099999999",
      "poi_longitude": "-97.6628647",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-267-6282",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-d264-74ce-b500-1b5689675993.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d264-74ce-b500-1b5689675993",
        "storage_key": "property/6767906449165636/019d2709-d264-74ce-b500-1b5689675993.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQWtxzOQFsocROaq5dE18-18",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f6b38c9c-50ff-4bb8-9ded-1136f8b92312",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Bethany YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "3400 N Mueller Ave, Bethany, OK 73008, USA",
      "poi_short_description": "Chain fitness center offering amenities such as a pool, basketball courts, and water aerobics classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-b30f-7212-bb52-39d05a36a578.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b30f-7212-bb52-39d05a36a578",
        "storage_key": "property/6767906449165636/019d2709-b30f-7212-bb52-39d05a36a578.webp",
        "width": 994,
        "height": 533
      },
      "poi_business_url": "https://ymcaokc.org/branches/bethany/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8306823524238509196&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bethany-ymca",
      "poi_latitude": "35.5051032",
      "poi_longitude": "-97.6316419",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-789-0231",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-d264-74ce-b500-1b5689675993.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d264-74ce-b500-1b5689675993",
        "storage_key": "property/6767906449165636/019d2709-d264-74ce-b500-1b5689675993.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9wBj710FsocRjEQY3vvDR3M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7cac09f5-0640-42b0-bc0b-01645084a48d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "6417 SW 3rd St, Oklahoma City, OK 73128, USA",
      "poi_short_description": "Retailer offering a variety of cosmetics, perfumes, and skin and hair care products, plus salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-b3f3-73db-bc5e-5071b830680a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b3f3-73db-bc5e-5071b830680a",
        "storage_key": "property/6767906449165636/019d2709-b3f3-73db-bc5e-5071b830680a.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/oklahoma-city-ok-280",
      "poi_directions_map_url": "https://maps.google.com/?cid=17811436559343706250&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "35.4630453",
      "poi_longitude": "-97.6282705",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-491-6223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-d264-74ce-b500-1b5689675993.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d264-74ce-b500-1b5689675993",
        "storage_key": "property/6767906449165636/019d2709-d264-74ce-b500-1b5689675993.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhy1t88kPsocRimAWgy7vLvc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_9cbfb357-ec91-45eb-aae8-534bfc8f06f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Bounce Academy Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "1901 W Vandament Ave, Yukon, OK 73099, USA",
      "poi_short_description": "Clean gymnastics center specializing in children’s classes and parties.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-b4c7-73cf-a04c-08c51a63b131.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b4c7-73cf-a04c-08c51a63b131",
        "storage_key": "property/6767906449165636/019d2709-b4c7-73cf-a04c-08c51a63b131.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bagymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9145115498533390941&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bounce-academy-gymnastics",
      "poi_latitude": "35.4942138",
      "poi_longitude": "-97.7726666",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-494-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-cebd-703a-a252-73c80e422ebb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-cebd-703a-a252-73c80e422ebb",
        "storage_key": "property/6767906449165636/019d2709-cebd-703a-a252-73c80e422ebb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN9_lNtwHsocRXYoA0Bf66X4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_98af2bc7-9abb-40c7-85ef-8bf208930787",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Rockwell Plaza YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "8300 Glade Ave, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Clean gym with a basketball court.",
      "poi_long_description": "People say this gym offers a pool and a variety of fitness equipment.\n\nOther reviews mention the staff can be unhelpful and the rules can be strict.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-b5df-737d-88f8-ae39df1f6a77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b5df-737d-88f8-ae39df1f6a77",
        "storage_key": "property/6767906449165636/019d2709-b5df-737d-88f8-ae39df1f6a77.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ymcaokc.org/branches/rockwell-plaza/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17719347020841965419&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rockwell-plaza-ymca",
      "poi_latitude": "35.5546582",
      "poi_longitude": "-97.6422942",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-621-5858",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-d264-74ce-b500-1b5689675993.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d264-74ce-b500-1b5689675993",
        "storage_key": "property/6767906449165636/019d2709-d264-74ce-b500-1b5689675993.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJleKdJ_AEsocRa1cp_TvE5_U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b14c34a9-4c72-4407-95d2-cc7ac0895219",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "10GYM",
      "poi_type": "Health and Wellness",
      "poi_address": "6209 Northwest Expy, Oklahoma City, OK 73132, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers top-of-the-line workouts tailored to individual goals. They highlight the trainers are knowledgeable, motivating, and passionate about helping clients achieve their fitness objectives. They also like the welcoming and supportive atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-b724-7466-8dbe-624f831b34ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b724-7466-8dbe-624f831b34ef",
        "storage_key": "property/6767906449165636/019d2709-b724-7466-8dbe-624f831b34ef.webp",
        "width": 606,
        "height": 341
      },
      "poi_business_url": "https://10gym.com/no-oklahoma-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4245080577524329760&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "10gym",
      "poi_latitude": "35.5537007",
      "poi_longitude": "-97.6255295",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-728-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-d264-74ce-b500-1b5689675993.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d264-74ce-b500-1b5689675993",
        "storage_key": "property/6767906449165636/019d2709-d264-74ce-b500-1b5689675993.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2Th3F9sEsocRIG0_OkuO6To",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0a2369ed-1378-4e3c-9cc8-301ebd655bdc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Bethany Children's Health Center",
      "poi_type": "Health and Wellness",
      "poi_address": "6800 NW 39th Expy, Bethany, OK 73008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-b87a-7033-832e-7454a53cfe17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b87a-7033-832e-7454a53cfe17",
        "storage_key": "property/6767906449165636/019d2709-b87a-7033-832e-7454a53cfe17.webp",
        "width": 800,
        "height": 599
      },
      "poi_business_url": "https://www.bethanychildrens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7263694039261901520&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bethany-childrens-health-center",
      "poi_latitude": "35.5107205",
      "poi_longitude": "-97.6341932",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-789-6711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-d260-763c-b362-acb46381c763.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d260-763c-b362-acb46381c763",
        "storage_key": "property/6767906449165636/019d2709-d260-763c-b362-acb46381c763.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJLWDqGmgFsocR0PJTdz7TzWQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_f9e78309-87a3-4847-847d-fda1ad9b534a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "INTEGRIS Health Emergency Department Canadian Valley Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1201 Health Center Pkwy, Yukon, OK 73099, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-b99f-766d-83b6-153e04ad6107.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b99f-766d-83b6-153e04ad6107",
        "storage_key": "property/6767906449165636/019d2709-b99f-766d-83b6-153e04ad6107.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://integrishealth.org/locations/emergency-room/integris-health-emergency-department-canadian-valley",
      "poi_directions_map_url": "https://maps.google.com/?cid=5498566190179253766&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "integris-health-emergency-department-canadian-valley-hospital",
      "poi_latitude": "35.4850381",
      "poi_longitude": "-97.7634018",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-717-6800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-d260-763c-b362-acb46381c763.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d260-763c-b362-acb46381c763",
        "storage_key": "property/6767906449165636/019d2709-d260-763c-b362-acb46381c763.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8X7G1MqvdIgRBn6bO9HUTkw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_d8ab361b-bb09-468b-8286-6706a971b9c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Chisholm Trail Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "500 W Vandament Ave, Yukon, OK 73099, USA",
      "poi_short_description": "Sprawling park for leisure and outdoor activities, featuring playgrounds and a pond.",
      "poi_long_description": "Visitors say this city park offers beautiful walking trails, a large playground, and a pond where you can feed ducks and geese. They also highlight the impressive Christmas light displays and drone shows during the holiday season.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-bacf-70af-a84f-7decff8925a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-bacf-70af-a84f-7decff8925a3",
        "storage_key": "property/6767906449165636/019d2709-bacf-70af-a84f-7decff8925a3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.yukonok.gov/457/Chisholm-Trail-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1454155337706392218&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chisholm-trail-park",
      "poi_latitude": "35.4899474",
      "poi_longitude": "-97.7484834",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-350-8937",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-d627-754c-b5f6-fe40245730b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d627-754c-b5f6-fe40245730b6",
        "storage_key": "property/6767906449165636/019d2709-d627-754c-b5f6-fe40245730b6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJoTTs53gIsocRmko6QJMyLhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_982bd9c0-5914-488f-a3f7-03d695f56dbb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Overholser Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9398-9000 S Overholser Rd, Oklahoma City, OK 73127, USA",
      "poi_short_description": "Peaceful park, lake and dam venue for walking, skating and biking.",
      "poi_long_description": "People say this park offers bike riding, fishing, kayaking, and walking trails. They highlight the relaxing and calm vibe, and the scenic views of the dam and lake. They also like the historic structure and the opportunity to walk across the dam.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-bc1a-7568-863d-8a0273440a3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-bc1a-7568-863d-8a0273440a3a",
        "storage_key": "property/6767906449165636/019d2709-bc1a-7568-863d-8a0273440a3a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/224/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13345590610054369473&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "overholser-park",
      "poi_latitude": "35.4843833",
      "poi_longitude": "-97.6681182",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-297-2756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-d627-754c-b5f6-fe40245730b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d627-754c-b5f6-fe40245730b6",
        "storage_key": "property/6767906449165636/019d2709-d627-754c-b5f6-fe40245730b6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6SWxWJkFsocRwVAUrvMPNbk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ac547d6e-e0cf-4774-b8e3-43483450b4a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Route 66 Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9901 NW 23rd St, Yukon, OK 73099, USA",
      "poi_short_description": "148 acres of ponds, trails & an observation tower with lake views, plus a Mother Road memorial.",
      "poi_long_description": "People say this park offers a great walking path, access to fishing, and a playground. They highlight the relaxing vibe, family-friendly atmosphere, and clean environment. They also like the long walkways and the scenic lake with ducks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-bd26-771b-a898-b1be4b9526cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-bd26-771b-a898-b1be4b9526cf",
        "storage_key": "property/6767906449165636/019d2709-bd26-771b-a898-b1be4b9526cf.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/32/2846",
      "poi_directions_map_url": "https://maps.google.com/?cid=90707035350423985&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "route-66-park",
      "poi_latitude": "35.4969132",
      "poi_longitude": "-97.6934847",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-297-3882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-d627-754c-b5f6-fe40245730b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d627-754c-b5f6-fe40245730b6",
        "storage_key": "property/6767906449165636/019d2709-d627-754c-b5f6-fe40245730b6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8YR1wPgFsocRsdmwbJFBQgE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6523d04a-6e68-4e48-9acc-eedcc0814a0e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Yukon Christmas in the Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2200 S Holly Ave, Yukon, OK 73099, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-be46-72cc-b0a8-92de57f834a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-be46-72cc-b0a8-92de57f834a2",
        "storage_key": "property/6767906449165636/019d2709-be46-72cc-b0a8-92de57f834a2.webp",
        "width": 1280,
        "height": 692
      },
      "poi_business_url": "https://www.yukonchristmas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3320141239171860691&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "yukon-christmas-in-the-park",
      "poi_latitude": "35.4829574",
      "poi_longitude": "-97.7492989",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-350-8937",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-d627-754c-b5f6-fe40245730b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d627-754c-b5f6-fe40245730b6",
        "storage_key": "property/6767906449165636/019d2709-d627-754c-b5f6-fe40245730b6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJaxniKQAJsocR08j2vN2CEy4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a07bed96-e296-42f1-99ed-9bb3c559fea9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Dolese Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5105 NW 50th St, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Park with picnic tables, a playground, a paved cycling trail, disc golf course, and facilities for baseball and fishing.",
      "poi_long_description": "People say this park offers a disc golf course, trails, a playground, and a pond for fishing. They highlight the beautiful scenery, the well-maintained trails, and the friendly people. They also like the calming atmosphere and the ample space for various activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-c0fb-704c-af1b-67183ca3d9fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c0fb-704c-af1b-67183ca3d9fd",
        "storage_key": "property/6767906449165636/019d2709-c0fb-704c-af1b-67183ca3d9fd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15736370327146326173&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dolese-park",
      "poi_latitude": "35.52624369999999",
      "poi_longitude": "-97.6055628",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-297-2756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-d627-754c-b5f6-fe40245730b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d627-754c-b5f6-fe40245730b6",
        "storage_key": "property/6767906449165636/019d2709-d627-754c-b5f6-fe40245730b6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcf9-e8kasocRneiNC3DRYto",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1e1f6ce0-9d69-4751-b1f9-5a26dbbce454",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Wiley Post Airport-PWA",
      "poi_type": "Transportation & Transit",
      "poi_address": "5915 Philip J Rhoads Ave, Bethany, OK 73008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-c0d5-766b-8b23-f16b11a0cc8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c0d5-766b-8b23-f16b11a0cc8c",
        "storage_key": "property/6767906449165636/019d2709-c0d5-766b-8b23-f16b11a0cc8c.webp",
        "width": 1280,
        "height": 1013
      },
      "poi_business_url": "http://www.wileypostairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17919166834402155680&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wiley-post-airport-pwa",
      "poi_latitude": "35.5307445",
      "poi_longitude": "-97.6430208",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-316-4061",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-d5fc-7114-aec3-e9d8fa4543cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d5fc-7114-aec3-e9d8fa4543cf",
        "storage_key": "property/6767906449165636/019d2709-d5fc-7114-aec3-e9d8fa4543cf.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_0-vGAMFsocRoFyAy0urrfg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_59b0fedd-aef5-4a91-b3d4-e066171bcab0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Sundance Airport KHSD",
      "poi_type": "Transportation & Transit",
      "poi_address": "13000 N Sara Rd, Yukon, OK 73099, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-c17a-753c-9db6-dad4db052794.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c17a-753c-9db6-dad4db052794",
        "storage_key": "property/6767906449165636/019d2709-c17a-753c-9db6-dad4db052794.webp",
        "width": 1280,
        "height": 478
      },
      "poi_business_url": "http://sundanceairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1335938299321620831&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sundance-airport-khsd",
      "poi_latitude": "35.601503",
      "poi_longitude": "-97.7069306",
      "poi_miles_from_property": "10.4",
      "poi_walking_minutes": "3 hours 45 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-373-3886",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-d5fc-7114-aec3-e9d8fa4543cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d5fc-7114-aec3-e9d8fa4543cf",
        "storage_key": "property/6767906449165636/019d2709-d5fc-7114-aec3-e9d8fa4543cf.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6eH4NUUBsocRX5nnHM40ihI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_6db7e804-aaa2-46e8-ad4f-5b29dc4b6eca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Jetset FBO",
      "poi_type": "Transportation & Transit",
      "poi_address": "7220 NW 63rd St, Bethany, OK 73008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-c25e-7759-8b64-46d551a1ebc3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c25e-7759-8b64-46d551a1ebc3",
        "storage_key": "property/6767906449165636/019d2709-c25e-7759-8b64-46d551a1ebc3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.jetsetfbo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=522519284200811341&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jetset-fbo",
      "poi_latitude": "35.5368188",
      "poi_longitude": "-97.6412624",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-888-8684",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-d5fc-7114-aec3-e9d8fa4543cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d5fc-7114-aec3-e9d8fa4543cf",
        "storage_key": "property/6767906449165636/019d2709-d5fc-7114-aec3-e9d8fa4543cf.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJm1b0wrcFsocRTasUQ4VcQAc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_8161b7b8-38df-4d5a-bbf8-6cd99839ec0d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "7725 Connect",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7725 W Reno Ave, Oklahoma City, OK 73127, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-c553-727e-b277-76d7d0b62739.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c553-727e-b277-76d7d0b62739",
        "storage_key": "property/6767906449165636/019d2709-c553-727e-b277-76d7d0b62739.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://7725connect.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7415117686874367476&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "7725-connect",
      "poi_latitude": "35.4651921",
      "poi_longitude": "-97.6493758",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-232-3242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-d264-74ce-b500-1b5689675993.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d264-74ce-b500-1b5689675993",
        "storage_key": "property/6767906449165636/019d2709-d264-74ce-b500-1b5689675993.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT4bmHaYPsocR9OXczT_K52Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c02a47b1-b925-4840-b041-fa37065ccead",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Schlumberger TLM-D&M",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10546 NW 10th St, Oklahoma City, OK 73127, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-c5c7-7639-8ffd-473e787bda7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c5c7-7639-8ffd-473e787bda7b",
        "storage_key": "property/6767906449165636/019d2709-c5c7-7639-8ffd-473e787bda7b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16503236905686134745&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "schlumberger-tlm-dm",
      "poi_latitude": "35.4771982",
      "poi_longitude": "-97.7056063",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-709-1731",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-d264-74ce-b500-1b5689675993.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d264-74ce-b500-1b5689675993",
        "storage_key": "property/6767906449165636/019d2709-d264-74ce-b500-1b5689675993.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa0NXwLYIsocR2e-JH4dGB-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_b78a47a7-8673-4693-bc17-5982d51fbdd1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Express Employment International",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9701 Boardwalk Blvd, Oklahoma City, OK 73162, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-c740-7291-88d3-7e97950d4744.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c740-7291-88d3-7e97950d4744",
        "storage_key": "property/6767906449165636/019d2709-c740-7291-88d3-7e97950d4744.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.expresspros.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=92586903052956857&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "express-employment-international",
      "poi_latitude": "35.56707",
      "poi_longitude": "-97.666693",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-840-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-d264-74ce-b500-1b5689675993.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d264-74ce-b500-1b5689675993",
        "storage_key": "property/6767906449165636/019d2709-d264-74ce-b500-1b5689675993.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr6z8UW8EsocRuTRTO0zvSAE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_5425a233-44cb-4c32-a8ed-75b8a67b08ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "CACI",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7725 W Reno Ave, Oklahoma City, OK 73127, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-c668-77a5-82b9-40ab61c6929b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c668-77a5-82b9-40ab61c6929b",
        "storage_key": "property/6767906449165636/019d2709-c668-77a5-82b9-40ab61c6929b.webp",
        "width": 961,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=822969494413870097&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "caci",
      "poi_latitude": "35.4653077",
      "poi_longitude": "-97.6494573",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-d264-74ce-b500-1b5689675993.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d264-74ce-b500-1b5689675993",
        "storage_key": "property/6767906449165636/019d2709-d264-74ce-b500-1b5689675993.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw22o8XEPsocREYSFF2XGaws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c4731390-f230-4a6b-bcbd-34eef18e5f63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Pacebutler Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5915 NW 23rd St, Oklahoma City, OK 73127, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-ca06-7110-872b-0607cfbb5d34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-ca06-7110-872b-0607cfbb5d34",
        "storage_key": "property/6767906449165636/019d2709-ca06-7110-872b-0607cfbb5d34.webp",
        "width": 500,
        "height": 333
      },
      "poi_business_url": "http://www.pacebutler.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8557959088291269970&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pacebutler-corporation",
      "poi_latitude": "35.4936498",
      "poi_longitude": "-97.6204189",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-755-3131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d2709-d264-74ce-b500-1b5689675993.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d264-74ce-b500-1b5689675993",
        "storage_key": "property/6767906449165636/019d2709-d264-74ce-b500-1b5689675993.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEZOm26MesocRUk3t43L6w3Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_1a936d47-3cd0-4a37-9b2a-1a3ec0aefc59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Parkland Elementary School",
      "poi_type": "Education",
      "poi_address": "2201 Cornwell Dr, Yukon, OK 73099, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://parkland.yukonps.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17653703233212391252&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "parkland-elementary-school",
      "poi_latitude": "35.4857873",
      "poi_longitude": "-97.7417497",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-354-7786",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-95c4-74eb-886c-af0175134bd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-95c4-74eb-886c-af0175134bd7",
        "storage_key": "property/6767906449165636/019cfb4a-95c4-74eb-886c-af0175134bd7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJt7Q0kn0IsocRVB_KqY6N_vQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_fe2b0c83-1e1d-485e-8ee3-3362f3fac479",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Shedeck Elementary School",
      "poi_type": "Education",
      "poi_address": "2100 S Holly Ave, Yukon, OK 73099, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d7913-68ee-7446-b17f-bb5d67fe1c2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-68ee-7446-b17f-bb5d67fe1c2c",
        "storage_key": "property/6767906449165636/019d7913-68ee-7446-b17f-bb5d67fe1c2c.webp",
        "width": 726,
        "height": 1280
      },
      "poi_business_url": "https://shedeck.yukonps.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18084680664760957988&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "shedeck-elementary-school",
      "poi_latitude": "35.4856974",
      "poi_longitude": "-97.7520544",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-354-6601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-95c4-74eb-886c-af0175134bd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-95c4-74eb-886c-af0175134bd7",
        "storage_key": "property/6767906449165636/019cfb4a-95c4-74eb-886c-af0175134bd7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJo3Vhy2QIsocRJLxzcz-x-fo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_44a18791-9eab-40a6-b7c8-5dee349d2616",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Lakeview Intermediate School",
      "poi_type": "Education",
      "poi_address": "872 S Yukon Pkwy, Yukon, OK 73099, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17388362512768812180&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lakeview-intermediate-school",
      "poi_latitude": "35.4995268",
      "poi_longitude": "-97.7224349",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-265-1342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-95c4-74eb-886c-af0175134bd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-95c4-74eb-886c-af0175134bd7",
        "storage_key": "property/6767906449165636/019cfb4a-95c4-74eb-886c-af0175134bd7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJNSn9RSEGsocRlMRN75PfT_E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_b54c5d5e-d995-4fe8-af46-eaa7aa7de37a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Yukon Middle School 7th & 8th Grade Center",
      "poi_type": "Education",
      "poi_address": "801 Garth Brooks Blvd, Yukon, OK 73099, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d7913-6892-72a1-82a5-f4538339572e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-6892-72a1-82a5-f4538339572e",
        "storage_key": "property/6767906449165636/019d7913-6892-72a1-82a5-f4538339572e.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12024947542281503651&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "yukon-middle-school-7th-8th-grade-center",
      "poi_latitude": "35.4984861",
      "poi_longitude": "-97.759162",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-354-5274",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-95c4-74eb-886c-af0175134bd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-95c4-74eb-886c-af0175134bd7",
        "storage_key": "property/6767906449165636/019cfb4a-95c4-74eb-886c-af0175134bd7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMeGeadwHsocRo0NlLBQy4aY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_a83e4fb7-2d60-4836-bbb4-81a154973258",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Yukon Public Schools - Yukon High School",
      "poi_type": "Education",
      "poi_address": "1777 S Yukon Pkwy, Yukon, OK 73099, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://nass.yukonps.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12168413359951489108&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "yukon-public-schools-yukon-high-school",
      "poi_latitude": "35.4883402",
      "poi_longitude": "-97.7269149",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-354-6692",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-95c4-74eb-886c-af0175134bd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-95c4-74eb-886c-af0175134bd7",
        "storage_key": "property/6767906449165636/019cfb4a-95c4-74eb-886c-af0175134bd7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCWZaUdQHsocRVKgG2Hrj3qg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_31b1ece2-98e9-43bb-bb70-eb8e498d426c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Yukon Public Schools",
      "poi_type": "Education",
      "poi_address": "Yukon Public Schools, OK, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12408211243268166654&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "yukon-public-schools",
      "poi_latitude": "35.5154924",
      "poi_longitude": "-97.7199454",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-95b0-73bb-a561-eb4e44133da2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-95b0-73bb-a561-eb4e44133da2",
        "storage_key": "property/6767906449165636/019cfb4a-95b0-73bb-a561-eb4e44133da2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNdyRL64HsocR_tMBXWLSMqw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c57a97a5-e36a-4a51-8749-29d1a6ad8754",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Panang 9 Thai Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2121 S Yukon Pkwy Suite 145, Yukon, OK 73099, USA",
      "poi_short_description": "Relaxed option for classic Thai fare, from noodles and curries to fried rice.",
      "poi_long_description": "People say this Thai restaurant serves delicious and flavorful dishes, including Bangkok fried rice, pad Thai, and khao soi. They highlight the generous portions, perfect for sharing family style, and the trendy, memorable atmosphere, ideal for a date night. They also like the attentive and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d7913-6a70-7308-ab4e-9ba1e9eb8b4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-6a70-7308-ab4e-9ba1e9eb8b4f",
        "storage_key": "property/6767906449165636/019d7913-6a70-7308-ab4e-9ba1e9eb8b4f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://panangthaifood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1381464738846241335&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "panang-9-thai-restaurant",
      "poi_latitude": "35.4820449",
      "poi_longitude": "-97.7257182",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-467-5333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-95af-705e-a640-39ad831e27cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-95af-705e-a640-39ad831e27cf",
        "storage_key": "property/6767906449165636/019cfb4a-95af-705e-a640-39ad831e27cf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgX1zO54JsocRN3KoVNzyKxM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_1c27b838-d819-4da8-baa4-9b2eae2fd2f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "McClintock Saloon & Chop House",
      "poi_type": "Restaurants",
      "poi_address": "2227 Exchange Ave, Oklahoma City, OK 73108, USA",
      "poi_short_description": "Relaxed spot serving steaks, burgers and prime rib alongside cocktails.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, burgers, and chicken fried steak. They also highlight the great atmosphere, with wood and velvet booths, chandeliers, and carvings, and the exceptional whiskey menu.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d7913-6724-745f-9b5f-85cbfbdc2be5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-6724-745f-9b5f-85cbfbdc2be5",
        "storage_key": "property/6767906449165636/019d7913-6724-745f-9b5f-85cbfbdc2be5.webp",
        "width": 538,
        "height": 304
      },
      "poi_business_url": "http://mcclintocksaloon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17151538246475803024&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mcclintock-saloon-chop-house",
      "poi_latitude": "35.4530152",
      "poi_longitude": "-97.5542409",
      "poi_miles_from_property": "11.7 mi",
      "poi_walking_minutes": "4 hours 18 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-232-0151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-95af-705e-a640-39ad831e27cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-95af-705e-a640-39ad831e27cf",
        "storage_key": "property/6767906449165636/019cfb4a-95af-705e-a640-39ad831e27cf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYwT-qxsRsocRkGm3lCmBBu4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_c72eb3ee-4658-418f-84a8-936aa36199c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Vast",
      "poi_type": "Restaurants",
      "poi_address": "333 W Sheridan Ave 49th Floor, Oklahoma City, OK 73102, USA",
      "poi_short_description": "New American fine dining & cocktails on the 49th floor, with private rooms & event space available.",
      "poi_long_description": "People say this American restaurant offers a delicious lunch buffet with a rotating menu, featuring options like shrimp and poblano grits, and a dessert bar with creme brulee. They highlight the incredible views of the city from the 49th floor, the elegant and welcoming atmosphere, and the professional and attentive service. They also like the great value of the lunch buffet and the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d7913-72dd-70e9-a450-27a27b508e28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-72dd-70e9-a450-27a27b508e28",
        "storage_key": "property/6767906449165636/019d7913-72dd-70e9-a450-27a27b508e28.webp",
        "width": 1280,
        "height": 942
      },
      "poi_business_url": "http://www.vastokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17764016300641992691&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "vast",
      "poi_latitude": "35.4669456",
      "poi_longitude": "-97.517715",
      "poi_miles_from_property": "13.0 mi",
      "poi_walking_minutes": "4 hours 48 mins",
      "poi_biking_minutes": "1 hour 27 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 405-702-7262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-95af-705e-a640-39ad831e27cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-95af-705e-a640-39ad831e27cf",
        "storage_key": "property/6767906449165636/019cfb4a-95af-705e-a640-39ad831e27cf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf1qdbykXsocR878DKLV2hvY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_f7a7525a-925c-49e2-8741-bea63ad98a1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Redrock Canyon Grill",
      "poi_type": "Restaurants",
      "poi_address": "9221 Lake Hefner Pkwy, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Easygoing bistro & bar turning out wood-fired rotisserie chicken & Southwest-inspired dishes.",
      "poi_long_description": "People say this American restaurant serves delicious roasted chicken, filet, and ribs, and the house salad with cornbread croutons is a highlight. They highlight the beautiful lake views, especially at sunset, and the lively, upbeat atmosphere. They also like the attentive and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d7913-71f0-768f-bcf9-62f989db9489.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-71f0-768f-bcf9-62f989db9489",
        "storage_key": "property/6767906449165636/019d7913-71f0-768f-bcf9-62f989db9489.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.redrockcanyongrill.com/locations/redrock-canyon-grill-okc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18024707086159946252&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "redrock-canyon-grill",
      "poi_latitude": "35.5637167",
      "poi_longitude": "-97.5781056",
      "poi_miles_from_property": "10.4 mi",
      "poi_walking_minutes": "3 hours 49 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 405-749-1995",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-95af-705e-a640-39ad831e27cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-95af-705e-a640-39ad831e27cf",
        "storage_key": "property/6767906449165636/019cfb4a-95af-705e-a640-39ad831e27cf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_f3w5AsbsocRDKIHi5ifJPo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_426a5652-2379-40c2-b73d-fd5c70acfe5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Michael's Grill",
      "poi_type": "Restaurants",
      "poi_address": "2824 W Country Club Dr, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Traditional restaurant offering lobster tails, caesar salads & steaks, along with wine & cocktails.",
      "poi_long_description": "Traditional restaurant offering lobster tails, caesar salads & steaks, along with wine & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d7913-7888-7515-8537-c4e672096199.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-7888-7515-8537-c4e672096199",
        "storage_key": "property/6767906449165636/019d7913-7888-7515-8537-c4e672096199.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://michaelsgrillokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14432248066412458593&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "michael-s-grill",
      "poi_latitude": "35.5469191",
      "poi_longitude": "-97.564716",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 39 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 405-810-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-95af-705e-a640-39ad831e27cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-95af-705e-a640-39ad831e27cf",
        "storage_key": "property/6767906449165636/019cfb4a-95af-705e-a640-39ad831e27cf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_7RqM6sbsocRYTLVrCalScg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_deac28b5-4f1b-49fd-abae-d3fbc410b21d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "LongHorn Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "12400 NW 10th St, Yukon, OK 73099, USA",
      "poi_short_description": "Casual steakhouse chain known for grilled beef & other American dishes in a ranch-style space.",
      "poi_long_description": "People say this steakhouse serves delicious ribeye steaks, salmon with bourbon glaze, and crispy Brussels sprouts. They highlight the friendly staff and attentive service, and the quiet and calm atmosphere. They also like the fresh bread and the lava cake dessert.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d7913-80f0-7222-bdf5-1a4e226a5be8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-80f0-7222-bdf5-1a4e226a5be8",
        "storage_key": "property/6767906449165636/019d7913-80f0-7222-bdf5-1a4e226a5be8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.longhornsteakhouse.com/locations/ok/yukon/yukon/5603?cmpid=br:lh_ag:ie_ch:loc_ca:LHGMB_sn:gmb_gt:yukon-ok-5603_pl:locurl_rd:1521",
      "poi_directions_map_url": "https://maps.google.com/?cid=3031842287044441608&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "longhorn-steakhouse",
      "poi_latitude": "35.4780393",
      "poi_longitude": "-97.7471043",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-324-2458",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-95af-705e-a640-39ad831e27cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-95af-705e-a640-39ad831e27cf",
        "storage_key": "property/6767906449165636/019cfb4a-95af-705e-a640-39ad831e27cf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbXpmGmkJsocRCLZKJn9EEyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_99ee05b7-41d1-48b6-afd4-bca40ed961d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1105 Garth Brooks Blvd, Yukon, OK 73099, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "People say this grocery store offers a great selection of fresh produce, meats, and grains, as well as a variety of breads and allergy-friendly options. They also highlight the friendly and helpful staff, and the clean and well-organized store.\n\nSome reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d7913-892b-776f-bbc3-c20d514c7064.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-892b-776f-bbc3-c20d514c7064",
        "storage_key": "property/6767906449165636/019d7913-892b-776f-bbc3-c20d514c7064.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sprouts.com/store/ok/yukon/yukon",
      "poi_directions_map_url": "https://maps.google.com/?cid=7942211131637048225&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "35.491729",
      "poi_longitude": "-97.758603",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-494-3054",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-95af-705e-a640-3db88eceab1e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-95af-705e-a640-3db88eceab1e",
        "storage_key": "property/6767906449165636/019cfb4a-95af-705e-a640-3db88eceab1e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUdYrUN8HsocRoSNh0PFmOG4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_d9658d8a-8d39-4208-9b4a-5e4180c19740",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Urban Boondocks",
      "poi_type": "Shopping & Retail",
      "poi_address": "115 W Main St, Yukon, OK 73099, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d7913-85a5-76fb-b615-0996415e50f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-85a5-76fb-b615-0996415e50f2",
        "storage_key": "property/6767906449165636/019d7913-85a5-76fb-b615-0996415e50f2.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://www.instagram.com/urbanboondocksmarket/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5751442527970194204&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "urban-boondocks",
      "poi_latitude": "35.5081134",
      "poi_longitude": "-97.7449476",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-578-4756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-95c0-732f-96b6-a6a6c171b5b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-95c0-732f-96b6-a6a6c171b5b1",
        "storage_key": "property/6767906449165636/019cfb4a-95c0-732f-96b6-a6a6c171b5b1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJEy7zecwHsocRHPO8uYE60U8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_6d5d56d9-7db2-4143-92ff-fe22fdec997b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Dusty Roads Marketplace LLC",
      "poi_type": "Shopping & Retail",
      "poi_address": "1237 Garth Brooks Blvd, Yukon, OK 73099, USA",
      "poi_short_description": "Indoor flea-market-like antique store featuring furniture, clothing and decor items sold by many vendors.",
      "poi_long_description": "People say this antique store offers a wide variety of interesting antiques, vintage items, and collectibles, as well as some new items like local honey and preserves. They highlight the reasonable prices, especially for some items, and the fun, nostalgic vibe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d7913-8680-727c-8ccc-381e520a43ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-8680-727c-8ccc-381e520a43ad",
        "storage_key": "property/6767906449165636/019d7913-8680-727c-8ccc-381e520a43ad.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7909134181618953657&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dusty-roads-marketplace-llc",
      "poi_latitude": "35.4895991",
      "poi_longitude": "-97.7578145",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-354-1550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-95c0-732f-96b6-a6a6c171b5b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-95c0-732f-96b6-a6a6c171b5b1",
        "storage_key": "property/6767906449165636/019cfb4a-95c0-732f-96b6-a6a6c171b5b1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJk-nzdXYIsocRuS1MQKLjwm0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_4b0116fc-10e5-411d-a336-287a3eea970f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Yukon Community Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "2200 S Holly Ave, Yukon, OK 73099, USA",
      "poi_short_description": "Community center and park featuring a gym, an auditorium, a playground, ponds and lit-up Christmas trees.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d7913-95a9-73b2-8ba6-4d31dede8e88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-95a9-73b2-8ba6-4d31dede8e88",
        "storage_key": "property/6767906449165636/019d7913-95a9-73b2-8ba6-4d31dede8e88.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.yukonok.gov/271/Yukon-Community-Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=17822335836444953487&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "yukon-community-center",
      "poi_latitude": "35.48207560000001",
      "poi_longitude": "-97.7488682",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-354-8442",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-95b0-73bb-a561-eb4e44133da2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-95b0-73bb-a561-eb4e44133da2",
        "storage_key": "property/6767906449165636/019cfb4a-95b0-73bb-a561-eb4e44133da2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDzvSIXsIsocRjwsENwSoVfc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "community_center"
    },
    {
      "id": "custom_ffd718da-576b-441c-aa50-70339f8207d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Academy Sports + Outdoors",
      "poi_type": "Shopping & Retail",
      "poi_address": "12324 NW 10th St, Yukon, OK 73099, USA",
      "poi_short_description": "Sporting goods chain selling athletic apparel & footwear, plus outdoor gear & fitness equipment.",
      "poi_long_description": "People say this outdoor sports store offers a wide variety of products, including clothing, sporting goods, and in-season equipment. They also highlight the friendly and helpful staff, and the clean and well-organized store.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d7913-96be-75e9-8648-1c48a1d4e0a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-96be-75e9-8648-1c48a1d4e0a1",
        "storage_key": "property/6767906449165636/019d7913-96be-75e9-8648-1c48a1d4e0a1.webp",
        "width": 1137,
        "height": 640
      },
      "poi_business_url": "https://www.academy.com/storelocator/oklahoma/yukon/store-0246",
      "poi_directions_map_url": "https://maps.google.com/?cid=11454183656339890818&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "academy-sports-outdoors",
      "poi_latitude": "35.4758771",
      "poi_longitude": "-97.7475414",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-246-1429",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-95c0-732f-96b6-a6a6c171b5b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-95c0-732f-96b6-a6a6c171b5b1",
        "storage_key": "property/6767906449165636/019cfb4a-95c0-732f-96b6-a6a6c171b5b1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ3VRED2MIsocRgmI5PFlv9Z4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_10d3ea24-3449-4c80-979e-cc16f1945338",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Marshalls",
      "poi_type": "Shopping & Retail",
      "poi_address": "12444 NW 10th St, Oklahoma City, OK 73099, USA",
      "poi_short_description": "Retail chain offering brand-name clothing, accessories, shoes & housewares.",
      "poi_long_description": "Retail chain offering brand-name clothing, accessories, shoes & housewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d7913-9f12-7388-8a73-cf85eb551006.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-9f12-7388-8a73-cf85eb551006",
        "storage_key": "property/6767906449165636/019d7913-9f12-7388-8a73-cf85eb551006.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.marshalls.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=604062187718173081&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "marshalls",
      "poi_latitude": "35.4768298",
      "poi_longitude": "-97.74875",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-324-2218",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-95c0-732f-96b6-a6a6c171b5b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-95c0-732f-96b6-a6a6c171b5b1",
        "storage_key": "property/6767906449165636/019cfb4a-95c0-732f-96b6-a6a6c171b5b1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJKVubhGQIsocRmeEv-VsPYgg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_e44f99b0-fabb-4033-9400-82ed34261a11",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Walmart Garden Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "1200 Garth Brooks Blvd, Yukon, OK 73099, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d7913-a138-742a-bfdb-dfc7e2c3262e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-a138-742a-bfdb-dfc7e2c3262e",
        "storage_key": "property/6767906449165636/019d7913-a138-742a-bfdb-dfc7e2c3262e.webp",
        "width": 630,
        "height": 355
      },
      "poi_business_url": "https://www.walmart.com/store/221-yukon-ok/patio-garden-services/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=789562398700032923&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-garden-center",
      "poi_latitude": "35.4910068",
      "poi_longitude": "-97.7635096",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-350-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-95c0-732f-96b6-a6a6c171b5b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-95c0-732f-96b6-a6a6c171b5b1",
        "storage_key": "property/6767906449165636/019cfb4a-95c0-732f-96b6-a6a6c171b5b1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ04YlqQoIsocRm1OFftEW9Qo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden_center"
    },
    {
      "id": "custom_5b2c1083-d44a-4713-9540-755d5150ebc8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "1700 Garth Brooks Blvd, Yukon, OK 73099, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store offers a wide selection of products. They also highlight the friendly and helpful staff, and the clean and organized store.\n\nOther reviews mention the prices can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d7913-a15f-7448-b9e8-ebcce0035c52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-a15f-7448-b9e8-ebcce0035c52",
        "storage_key": "property/6767906449165636/019d7913-a15f-7448-b9e8-ebcce0035c52.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/yukon/2460",
      "poi_directions_map_url": "https://maps.google.com/?cid=4957380202334099076&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "35.4808576",
      "poi_longitude": "-97.7639113",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-494-3179",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-95c0-732f-96b6-a6a6c171b5b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-95c0-732f-96b6-a6a6c171b5b1",
        "storage_key": "property/6767906449165636/019cfb4a-95c0-732f-96b6-a6a6c171b5b1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJz8m1e98HsocRhJatWAcnzEQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_cf381539-05c7-4fc7-9a61-2db4e531bc42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Chisholm Trail Park Boot Hill",
      "poi_type": "Entertainment",
      "poi_address": "Yukon, OK 73099, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yukonok.gov/457/Chisholm-Trail-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=8095728825087428702&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chisholm-trail-park-boot-hill",
      "poi_latitude": "35.4907353",
      "poi_longitude": "-97.7475861",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-95b0-73bb-a561-eb4e44133da2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-95b0-73bb-a561-eb4e44133da2",
        "storage_key": "property/6767906449165636/019cfb4a-95b0-73bb-a561-eb4e44133da2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGSZKLQAJsocRXgg6MXnOWXA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_97a4df5c-729b-481a-884a-9d63628d0996",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Lake Overholser",
      "poi_type": "Entertainment",
      "poi_address": "Lake Overholser, Oklahoma City, OK, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d7913-a947-769b-bf95-edacbb61d22b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-a947-769b-bf95-edacbb61d22b",
        "storage_key": "property/6767906449165636/019d7913-a947-769b-bf95-edacbb61d22b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12443752392555701826&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lake-overholser",
      "poi_latitude": "35.5015933",
      "poi_longitude": "-97.681943",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-95b0-73bb-a561-eb4e44133da2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-95b0-73bb-a561-eb4e44133da2",
        "storage_key": "property/6767906449165636/019cfb4a-95b0-73bb-a561-eb4e44133da2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiy_-CPUFsocRQiYzB98Wsaw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "lake"
    },
    {
      "id": "custom_27e63c15-3489-410a-bc28-ca28382d43a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Stinchcomb Wildlife Refuge",
      "poi_type": "Entertainment",
      "poi_address": "5100 N Stinchcomb Ave, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Forested wildlife area for hiking, bird-watching, fishing & biking as well as kayaking.",
      "poi_long_description": "People say this wildlife refuge offers hiking trails, kayaking, and fishing opportunities. They highlight the beautiful scenery, access to the river, and the abundance of wildlife, including birds and snakes. They also like the opportunity to get off in nature and enjoy a peaceful escape.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d7913-ae0c-752d-9522-76a78e565274.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-ae0c-752d-9522-76a78e565274",
        "storage_key": "property/6767906449165636/019d7913-ae0c-752d-9522-76a78e565274.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.okc.gov/departments/parks-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=16862425980734090786&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "stinchcomb-wildlife-refuge",
      "poi_latitude": "35.5227424",
      "poi_longitude": "-97.6633716",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-297-3882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-95bf-75ef-858a-25fac3b0aebf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-95bf-75ef-858a-25fac3b0aebf",
        "storage_key": "property/6767906449165636/019cfb4a-95bf-75ef-858a-25fac3b0aebf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ85Pzk84FsocRIi75qBZfA-o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wildlife_refuge"
    },
    {
      "id": "custom_3c5a6db3-6157-4e14-9b83-14dfb96847a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Oklahoma City Zoo",
      "poi_type": "Entertainment",
      "poi_address": "2000 Remington Pl, Oklahoma City, OK 73111, USA",
      "poi_short_description": "Zoo with an array of animals, plus walking trails, shows & attractions such as train tours.",
      "poi_long_description": "Visitors say this zoo offers a wide variety of animals, including elephants, giraffes, stingrays, and a petting zoo, with fun activities like giraffe feeding and a splash pad. They also highlight the friendly and helpful staff, the clean and well-maintained facilities, and the affordable prices, especially with discounts for families and military members.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019d7913-b023-7468-abbc-760e9fe01869.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-b023-7468-abbc-760e9fe01869",
        "storage_key": "property/6767906449165636/019d7913-b023-7468-abbc-760e9fe01869.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://okczoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5013321368135377402&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-city-zoo",
      "poi_latitude": "35.5238895",
      "poi_longitude": "-97.4724932",
      "poi_miles_from_property": "13.9 mi",
      "poi_walking_minutes": "5 hours 10 mins",
      "poi_biking_minutes": "1 hour 34 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 405-424-3344",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-95b0-73bb-a561-eb4e44133da2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-95b0-73bb-a561-eb4e44133da2",
        "storage_key": "property/6767906449165636/019cfb4a-95b0-73bb-a561-eb4e44133da2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg_EZ4YPguocR-qGV_DjlkkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_86f2f545-2b10-4d57-918e-59a5b944ec1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Interurban Resturaunt",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "interurban-resturaunt",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_895b1e43-7807-42d6-bee2-32ed720aedea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "poi_name": "Bikes & Brews Tour",
      "poi_type": "Entertainment",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "bikes-brews-tour",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_3196f9d16e35a1678bac26b7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_37422ec38d32b98f000bb59c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_e522e42fefa41bb7f84e2462",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_fa5f3670796f8a95d3b98bcb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_4463fe270e74b7b3d236ba01",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_91bedc7e75bd13bf40a6925c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_6e4ac10f-0a7b-4c80-b865-e31a25397e42",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "rating": "5.0",
      "name": "Rhys Wheeler",
      "text": "Staff and maintenance are extremely friendly and helpful. We've had to make some adjustments to our lease and they made it effortless and clearly established all expectations. They also remember who we are and always welcome us with a smile any time we need to go to the apartment offices.",
      "date": "2025-09-05",
      "title": ""
    },
    {
      "id": "custom_8ae6a19f-1403-42a0-84e2-664886eee3e0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "rating": "5.0",
      "name": "Carolee Perry",
      "text": "Moved in a few weeks ago from out of state WITHOUT seeing the apartment. Joshua was super nice and went and took a video of the exact apartment I was interested in. I emailed him constantly with questions since I wasn't able to see the place and area in person. He was always so patient and kind. We drove 13 hours there and the process of signing in was a breeze since we were able to do everything online. That definitely was a big PLUS after a long day of driving and packing the day prior. Everything has been perfect and I feel at peace here. I met Jazmine and the other woman (can't remember her name) and they have both been absolutely sweet. They have treats and toys inside for the dogs and I have gone in several times to let my dog enjoy the complex also. The dog park is nice also. I have mega storage in my one bedroom apartment. Nice fireplace with a heater. Blinds included. For a one bedroom, I think it’s a nice size! And they gave me info to rent a washer and dryer. Came in days, quick install, and very clean. Right next door is a huge field of prairie dogs and I love driving by and seeing them. I couldn't be happier here. Great location, great staff, and I love the apartment.",
      "date": "2024-12-03",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_61bd351c-8bac-4ae6-b079-7710fe575cea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4b-9b69-769b-9d03-953cd24e6ab2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of a modern apartment kitchen and living area with high ceilings and large windows.",
        "public_id": "019cfb4b-9b69-769b-9d03-953cd24e6ab2",
        "storage_key": "property/6767906449165636/019cfb4b-9b69-769b-9d03-953cd24e6ab2.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Ridge at 66 Apts Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=660afe5e28048814d5ac12a6"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-613b-741f-96ec-ac42e963363a",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "the-ridge-@-66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636"
    },
    {
      "lead_collector_id": "019cf79e-61af-729b-a4cd-5a368e94b7a3",
      "lead_source": "LANDING_PAGE",
      "name": "the-ridge-@-66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "generator",
      "page_item_url": "yukon-ok-apartments-with-pool",
      "search_query": "apartments with pool in Yukon OK",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Yukon, OK",
      "h2_subtitle": "Searching for apartments with a pool in Yukon, OK? Discover resort-style living at The Ridge @ 66, featuring a sparkling pool and spacious floor plans.",
      "page_copy": "Experience the pinnacle of comfort and convenience at The Ridge @ 66, when searching for apartments with a pool in Yukon, OK. Our residents enjoy access to a stunning pool, perfect for relaxation and recreation under the Oklahoma sun. Choose from our selection of one to three-bedroom apartments, each thoughtfully designed with modern amenities like ceiling fans and dishwashers.\n\nAs one of the top choices for those seeking an apartment with pool access, The Ridge @ 66 also offers an inviting clubhouse and a dedicated pet play area, ensuring both you and your furry friends have a fantastic living experience. Discover why our community is the ideal destination for sophisticated living in Yukon by scheduling a tour with us today. ",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-7450-706b-bd60-88b1d91538e9.webp",
      "featured_image_media": {
        "alt_text": "Living room and kitchen area of an apartment with blue sofa, coffee table, island with bar stools, and stainless steel refrigerator.",
        "public_id": "019cfb4a-7450-706b-bd60-88b1d91538e9",
        "storage_key": "property/6767906449165636/019cfb4a-7450-706b-bd60-88b1d91538e9.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Yukon OK Apartments with Pool | The Ridge @ 66",
      "seo_description": "Explore The Ridge @ 66 in Yukon, OK - premier apartments with a pool and exceptional amenities. Enjoy luxury living close to local attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "generator",
      "page_item_url": "stonebridge-west-pet-friendly-apartments-dog-park",
      "search_query": "pet-friendly apartments with dog park in Stonebridge West",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Stonebridge West",
      "h2_subtitle": "Looking for pet-friendly apartments with a dog park in Stonebridge West? Discover The Ridge @ 66 for an unparalleled living experience.",
      "page_copy": "Embark on a new adventures at The Ridge @ 66 in the heart of Stonebridge West, where pet-friendly living meets luxury and convenience. Our community proudly offers a dog park, providing a perfect haven for your four-legged friends to run and play. Choose from spacious one to three-bedroom layouts, each designed to accommodate a modern lifestyle with quality amenities like carpet and ceiling fans.\n\nThe Ridge @ 66 stands out as a prime choice for those seeking pet-friendly apartments in Stonebridge West. Beyond our dedicated dog park, residents enjoy a vibrant community atmosphere enhanced by features such as a sparkling pool and a welcoming clubhouse. Let us be part of your journey; schedule a tour today and see firsthand why The Ridge @ 66 is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-7450-706b-bd60-88b1d91538e9.webp",
      "featured_image_media": {
        "alt_text": "Living room and kitchen area of an apartment with blue sofa, coffee table, island with bar stools, and stainless steel refrigerator.",
        "public_id": "019cfb4a-7450-706b-bd60-88b1d91538e9",
        "storage_key": "property/6767906449165636/019cfb4a-7450-706b-bd60-88b1d91538e9.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments with Dog Park | Stonebridge West",
      "seo_description": "Discover The Ridge @ 66 in Stonebridge West - pet-friendly living with a dog park and spacious apartments. Perfect for you and your furry friends.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "generator",
      "page_item_url": "yukon-ok-air-conditioned-apartments-walk-in-closets",
      "search_query": "air conditioned apartments with walk-in closets in Yukon Oklahoma",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Yukon, OK",
      "h2_subtitle": "Searching for air conditioned apartments with walk-in closets in Yukon, Oklahoma? Discover the spacious elegance at The Ridge @ 66.",
      "page_copy": "Discover the perfect blend of comfort and style at The Ridge @ 66 in Yukon, Oklahoma. If you're in the market for air conditioned apartments with walk-in closets, you've found the ideal spot. Our homes are equipped with modern amenities designed to enhance your lifestyle, featuring air conditioning for year-round comfort and ample walk-in closet spaces to accommodate your belongings.\n\nThe Ridge @ 66 offers more than just a place to live; it's a community that complements your lifestyle. Residents enjoy additional perks like a sparkling pool, pet play area, and inviting clubhouse. Whether you're looking for a cozy one-bedroom or a spacious three-bedroom layout, our apartments are ready to welcome you to superior living in Yukon. Come see what makes us distinct by scheduling a tour today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-7450-706b-bd60-88b1d91538e9.webp",
      "featured_image_media": {
        "alt_text": "Living room and kitchen area of an apartment with blue sofa, coffee table, island with bar stools, and stainless steel refrigerator.",
        "public_id": "019cfb4a-7450-706b-bd60-88b1d91538e9",
        "storage_key": "property/6767906449165636/019cfb4a-7450-706b-bd60-88b1d91538e9.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Yukon, OK | Walk-in Closets",
      "seo_description": "Explore The Ridge @ 66 in Yukon, OK - stylish air conditioned apartments with walk-in closets. Enjoy a luxurious living experience today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "generator",
      "page_item_url": "73099-apartments-clubhouse-fitness-center",
      "search_query": "apartments with clubhouse and fitness center 73099",
      "category": "Amenity",
      "h1_title": "Apartments with Clubhouse in 73099",
      "h2_subtitle": "Looking for apartments with a clubhouse and fitness center in 73099? Discover the exceptional amenities at The Ridge @ 66 in Yukon.",
      "page_copy": "Enhance your lifestyle at The Ridge @ 66, offering superb apartments with a clubhouse and proximity to a range of local activities in the 73099 area. Our vibrant community not only offers a welcoming clubhouse perfect for social gatherings but also embraces an active lifestyle with other impressive amenities. While we focus on the clubhouse experience, our resort-style facilities ensure every resident has access to luxury and comfort.\n\nLocated in the heart of Yukon, The Ridge @ 66 takes pride in offering spacious one to three-bedroom homes coupled with modern comforts like dishwashers and ceiling fans. With a sparkling pool and pet play area on-site, residents can enjoy a dynamic living environment. Join us today and experience firsthand why we are one of Yukon’s premier residential communities. Schedule a tour to discover more!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-7450-706b-bd60-88b1d91538e9.webp",
      "featured_image_media": {
        "alt_text": "Living room and kitchen area of an apartment with blue sofa, coffee table, island with bar stools, and stainless steel refrigerator.",
        "public_id": "019cfb4a-7450-706b-bd60-88b1d91538e9",
        "storage_key": "property/6767906449165636/019cfb4a-7450-706b-bd60-88b1d91538e9.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Clubhouse in 73099 | The Ridge @ 66",
      "seo_description": "Discover The Ridge @ 66 in Yukon, OK, 73099 - featuring apartments with a clubhouse. Enjoy luxurious living with community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "generator",
      "page_item_url": "stonebridge-west-luxury-apartments-in-unit-dishwasher",
      "search_query": "luxury apartments with in-unit dishwasher in Stonebridge West",
      "category": "Amenity",
      "h1_title": "Luxury Apartments in Stonebridge West",
      "h2_subtitle": "Explore luxury apartments with in-unit dishwashers in Stonebridge West. Discover a lavish lifestyle at The Ridge @ 66.",
      "page_copy": "Experience unparalleled elegance at The Ridge @ 66, offering luxury apartments in Stonebridge West. Each residence is designed with modern conveniences, featuring in-unit dishwashers for easy daily living. From impressive interiors to premium finishes, our homes cater to discerning tastes and provide a sophisticated living environment.\n\nBeyond our stylish living spaces, residents enjoy community-wide resort-like amenities, including a sparkling pool and a vibrant clubhouse. Whether you're unwinding after a long day or entertaining guests, The Ridge @ 66 offers a backdrop of elegance and comfort. Situated in the welcoming neighborhood of Stonebridge West, these luxury apartments are waiting to be called home. Schedule a tour today to experience the exceptional lifestyle we offer firsthand.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-7450-706b-bd60-88b1d91538e9.webp",
      "featured_image_media": {
        "alt_text": "Living room and kitchen area of an apartment with blue sofa, coffee table, island with bar stools, and stainless steel refrigerator.",
        "public_id": "019cfb4a-7450-706b-bd60-88b1d91538e9",
        "storage_key": "property/6767906449165636/019cfb4a-7450-706b-bd60-88b1d91538e9.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Dishwasher | Stonebridge West",
      "seo_description": "Discover luxury living at The Ridge @ 66 in Stonebridge West - elegant apartments with in-unit dishwashers and resort-style amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-yukon-ok",
      "search_query": "1 bedroom apartments Yukon Oklahoma",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Yukon, OK",
      "h2_subtitle": "Discover charming 1 bedroom apartments in Yukon, Oklahoma at The Ridge @ 66. Experience comfort and style in a great location.",
      "page_copy": "Welcome to The Ridge @ 66, where our charming 1 bedroom apartments in Yukon, Oklahoma offer the perfect blend of comfort and sophistication. These thoughtfully designed homes provide a cozy retreat, ideal for singles or couples seeking a stylish lifestyle. Equipped with modern amenities, including air conditioning and walk-in closets, our apartments are tailored for efficiency and convenience.\n\nLocated in the heart of Yukon, The Ridge @ 66 offers a vibrant community atmosphere, featuring amenities like a sparkling pool, pet play area, and an inviting clubhouse. Our gated community ensures privacy and peace of mind, while nearby attractions and conveniences present a full spectrum of entertainment and dining options. Don’t miss the opportunity to make one of these exceptional 1 bedroom apartments your next home. Book a tour and see the difference!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-7450-706b-bd60-88b1d91538e9.webp",
      "featured_image_media": {
        "alt_text": "Living room and kitchen area of an apartment with blue sofa, coffee table, island with bar stools, and stainless steel refrigerator.",
        "public_id": "019cfb4a-7450-706b-bd60-88b1d91538e9",
        "storage_key": "property/6767906449165636/019cfb4a-7450-706b-bd60-88b1d91538e9.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Yukon, OK | The Ridge @ 66",
      "seo_description": "Explore The Ridge @ 66 for charming 1 bedroom apartments in Yukon, OK. Enjoy modern amenities and vibrant community living today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-near-stonebridge-west",
      "search_query": "2 bedroom apartments near Stonebridge West",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments Near Stonebridge West",
      "h2_subtitle": "Find spacious 2 bedroom apartments near Stonebridge West at The Ridge @ 66. Enjoy modern living in a vibrant community.",
      "page_copy": "Explore life at The Ridge @ 66, where our spacious 2 bedroom apartments near Stonebridge West offer the perfect setting for comfortable living. Each apartment is designed with style and functionality in mind, featuring open layouts and high-end finishes that cater to your lifestyle. With amenities such as in-unit dishwashers, ceiling fans, and ample storage, these homes are both practical and luxurious.\n\nOur community enhances everyday life with resort-style amenities like a glistening pool, a modern clubhouse, and a dedicated pet play area. Located just a short drive from the conveniences of Stonebridge West, residents enjoy easy access to shopping, dining, and entertainment. Make one of our 2 bedroom apartments your new home, and experience the serene yet connected lifestyle that comes with being part of The Ridge @ 66 community. Schedule a visit today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-7450-706b-bd60-88b1d91538e9.webp",
      "featured_image_media": {
        "alt_text": "Living room and kitchen area of an apartment with blue sofa, coffee table, island with bar stools, and stainless steel refrigerator.",
        "public_id": "019cfb4a-7450-706b-bd60-88b1d91538e9",
        "storage_key": "property/6767906449165636/019cfb4a-7450-706b-bd60-88b1d91538e9.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments Near Stonebridge West | The Ridge @ 66",
      "seo_description": "Discover The Ridge @ 66's spacious 2 bedroom apartments near Stonebridge West. Experience modern living with luxurious amenities today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165636",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-73099",
      "search_query": "3 bedroom apartments in 73099",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments in 73099",
      "h2_subtitle": "Explore spacious 3 bedroom apartments in the 73099 area at The Ridge @ 66. Enjoy ample living space and modern comforts.",
      "page_copy": "Discover the perfect family home at The Ridge @ 66, offering spacious 3 bedroom apartments in the 73099 area. Each apartment is thoughtfully designed to provide a comfortable and welcoming environment for families or roommates seeking ample space and modern style. With features like generous floor plans and high-quality finishes, our homes cater to diverse living arrangements and preferences.\n\nSituated in the lively city of Yukon, these 3 bedroom residences come with access to top-tier communal amenities, including a stunning pool, clubhouse, and convenient pet play area, ensuring fun and relaxation for everyone. The Ridge @ 66 is ideally located near shopping centers, schools, and dining options, making it the perfect choice for those who want convenience at their doorstep. Visit us today and experience firsthand the lifestyle we have to offer!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-7450-706b-bd60-88b1d91538e9.webp",
      "featured_image_media": {
        "alt_text": "Living room and kitchen area of an apartment with blue sofa, coffee table, island with bar stools, and stainless steel refrigerator.",
        "public_id": "019cfb4a-7450-706b-bd60-88b1d91538e9",
        "storage_key": "property/6767906449165636/019cfb4a-7450-706b-bd60-88b1d91538e9.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments in 73099 | The Ridge @ 66",
      "seo_description": "Find spacious 3 bedroom apartments in the 73099 area at The Ridge @ 66. Enjoy family-friendly living with luxurious amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5209"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-TL5SG4760Q"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151550"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/the-ridge-@-66/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PNFR5KMD"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165636/019d1bda-874b-772d-b12b-c4601e926746.pdf"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "3f792427-783d-4521-b859-0efe59189ecf"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "866-957-9398"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "647f7bd652f6bb60b0fb348b"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjhreksySGZ1WVVBc3pxaGUyaVhrVGc9PSIsInZhbHVlIjoibjh6YXpMQzZZNmYrZ0NKWGk5Umw0QT09IiwibWFjIjoiNTE5MGJhMjBiMTRlMThkNzIwOTdhZDdhNGMyMDA0NTBiMWRhMWE4ZjQ0MmJlYjk4ZjcxOWE1YjE4MjlkODExMyJ9"
    }
  ],
  "custom_qb_id": "5209",
  "custom_ga4_id": "G-TL5SG4760Q",
  "custom_repli_id": "10041151550",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/the-ridge-@-66/register/",
  "custom_google_gtm_id": "GTM-PNFR5KMD",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165636/019d1bda-874b-772d-b12b-c4601e926746.pdf",
  "custom_rentgrata_property_id": "3f792427-783d-4521-b859-0efe59189ecf",
  "custom_ppc_tracking_phone_number": "866-957-9398",
  "custom_residentboost_apartment_id": "647f7bd652f6bb60b0fb348b",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjhreksySGZ1WVVBc3pxaGUyaVhrVGc9PSIsInZhbHVlIjoibjh6YXpMQzZZNmYrZ0NKWGk5Umw0QT09IiwibWFjIjoiNTE5MGJhMjBiMTRlMThkNzIwOTdhZDdhNGMyMDA0NTBiMWRhMWE4ZjQ0MmJlYjk4ZjcxOWE1YjE4MjlkODExMyJ9"
};

export const generatedAt = '2026-08-27T21:35:39.948Z';
